 /* Celest PDP — Mobile & Desktop    
   - Swatches color + talla -> variant id
   - CTA enable/disable según selección
   - Size sheet: móvil arriba/abajo según espacio, cierra al tocar fuera / misma talla
   - Guía de tallas modal
   - Mini-cart LV (checkout negro + seguir comprando blanco) con envío gratis + ETA (normal y personalizada)
   - Galería: contador + barra (IntersectionObserver fallback por scroll)
   - Sincronización con carrito del tema (Prestige)
   - Loader animado: dentro de "Añadir a la cesta", dentro de "Finalizar la compra", y overlay al tocar icono de bolsa del header
   - **CELEST PERSONALIZATION**: botón con borde multicolor + modal de personalización con letras, colores, puntos, confirmación y resumen, y salida en cart/mini-cart
*/
// ✅ CELEST — Open GLOBAL mini-cart (con fallbacks seguros)
async function celestOpenGlobalMiniCart(cart){
  try{
    // 1) Si existe tu mini-cart global
    const g = window.CelestMiniCart;
    if (g){
      // intenta métodos comunes
      if (typeof g.open === 'function') { g.open(cart); return true; }
      if (typeof g.show === 'function') { g.show(cart); return true; }
      if (typeof g.toggle === 'function') { g.toggle(true, cart); return true; }
      // algunos lo exponen así:
      if (typeof g.render === 'function' && typeof g.openCart === 'function'){
        g.render(cart); g.openCart(); return true;
      }
    }

    // 2) Tu bridge (ya lo tienes en este mismo JS)
    document.dispatchEvent(new CustomEvent('celest:openMiniCart', { detail: { cart } }));
    return true;

  }catch(_e){
    return false;
  }
}

  /* === CELEST • PRE-ORDER detector (global, sin dependencias) =================
   - Lee data-preorder del root o product.metafields.custom.preorder del JSON
   - Expone helpers globales para el label del CTA y el estado
=============================================================================*/
window.__celestIsPreorder = function(){
  const r = document.getElementById('celest-mobile-pdp');
  if (!r) return false;
  const dsVal = (r.dataset?.preorder||'').toString().toLowerCase();
  if (dsVal === 'true' || dsVal === '1' || dsVal === 'yes') return true;
  try{
    const el = document.getElementById('ProductJson-celest-mobile-pdp');
    if (!el) return false;
    const p  = JSON.parse(el.textContent||'{}');
    const mf = p?.metafields?.custom?.preorder;
    const v  = (typeof mf==='object' && mf!==null) ? mf.value : mf;
    return String(v).toLowerCase()==='true';
  }catch(_){ return false; }
};

window.__celestAddLabel = function(){
  return window.__celestIsPreorder() ? 'Pre-ordenar' : 'Agregar a la bolsa';
};

(function(){
  const $  = (s, c=document)=>c.querySelector(s);
  const $$ = (s, c=document)=>Array.from(c.querySelectorAll(s));
  const isMobile = matchMedia('(max-width: 989px)');
  const onReady = fn => (document.readyState==='loading' ? document.addEventListener('DOMContentLoaded',fn,{once:true}) : fn());

  const safeJSON = el => { try{ return el ? JSON.parse(el.textContent||'{}') : null; }catch(_){ return null; } };
  function getProductData(root){
    let p = safeJSON(root.querySelector('#ProductJson-celest-mobile-pdp'));
    if(p?.variants) return p;
    const any = $$('.product__json,script[type="application/json"]', root).map(s=>safeJSON(s)).find(o=>o?.variants);
    if(any) return any;
    if(window.ShopifyAnalytics?.meta?.product) return ShopifyAnalytics.meta.product;
    if(window.meta?.product) return window.meta.product;
    return {variants:[], options:[]};
  }
  const norm = v => String(v||'').toLowerCase().trim();

  const fmtMoneyFromCents = (cents, locale, currency)=>{
    try{
      return (cents/100).toLocaleString(locale||document.documentElement.lang||'es-ES',{style:'currency',currency:currency||Shopify?.currency?.active||document.documentElement.dataset.currency||'EUR',minimumFractionDigits:0});
    }catch(_){
      return (Math.round(cents/100)).toString();
    }
  };
  const fmtCOP0 = cents=>{
    try { return (cents/100).toLocaleString('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0,maximumFractionDigits:0}); }
    catch(_){ return '$ ' + Math.round(cents/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.'); }
  };

  onReady(init);

  function init(){
    const root = document.getElementById('celest-mobile-pdp');
    if(!root) return;

    const product  = getProductData(root);
    const variants = product.variants || [];
    let selectedVariant = product.selected_or_first_available_variant || variants.find(v=>v.available) || variants[0] || null;

    /* ===== DATASET Loader (desde la sección) ===== */
    const ds = root.dataset;
    const LOADER_MODE       = (ds.loaderMode || 'spin').trim();            // off | spin | morph | both | sketch
    const SHOW_BTNS         = (ds.loaderShowButtons || 'true') === 'true';
    const SHOW_OVERLAY      = (ds.loaderShowOverlay || 'true') === 'true';
    const BTN_SIZE          = parseInt(ds.loaderBtnSize || '18', 10);
    const SPIN_MS           = parseInt(ds.loaderSpeed  || '900', 10);
    const OVER_SIZE         = parseInt(ds.loaderOverlaySize || '36', 10);
    const OVER_ALPHA        = parseInt(ds.loaderOverlayAlpha || '40', 10);
    const ICONS             = { add: ds.loaderAdd || '', checkout: ds.loaderCheckout || '', cart: ds.loaderCart || '' };
    const MORPH_MS          = parseInt(ds.morphSpeed || '1200', 10);
    const MORPH_PATHS_RAW   = (ds.morphPaths || '').trim();
    const SKETCH_IMG        = ds.sketchImg || '';
    const SKETCH_SIZE       = parseInt(ds.sketchSize || BTN_SIZE, 10);

    /* ===== Elementos base ===== */
    const form     = $('[data-product-form]', root) || $('form[action*="/cart/add"]', root);
    const idInput  = form?.querySelector('input[name="id"]');
    const addBtn   = $('.celestPdp__addBtn, button[name="add"], [data-add-to-cart], .product-form__submit', root);

    // Swatches (color)
    const swWrap   = $('.celestPdp__swatches', root);
    const colorLbl = $('.js-colorValue', root);
    const colorIndex = parseInt(swWrap?.dataset.optionIndex || '-1', 10);

    // Tallas
    const sizeBtn   = $('.js-openSizes', root);
    const sizeSheet = $('.celestPdp__sizeSheet', root);
    const sizeWrap  = $('.celestPdp__sizes', root);
    const sizeIndex = parseInt(sizeWrap?.dataset.optionIndex || '-1', 10);
    const hasSizeUI = !!(sizeWrap && $$('.celestPdp__size', sizeWrap).length);

    // Guía
    const guideWrap = $('.celestPdp__guideModal', root);
    const guideBody = $('.celestPdp__guideBody', root);

    // Galería
    const slidesEl   = $('#celestSlides', root) || $('.celestPdp__slides', root) || $('.product__media-list', root);
    const progressBar= $('.celestPdp__progressBar', root);
    const currentEl  = $('.celestPdp__counter .js-current', root);
    const totalEl    = $('.celestPdp__counter .js-total', root);

    /* ===== Utilidades CTA (actualizado: no deshabilitamos visualmente) ===== */
    function enableCTA(){
     if(!addBtn) return;
     addBtn.classList.add('is-ready');
     addBtn.disabled = false;
     addBtn.removeAttribute('aria-disabled');
    }
    function disableCTA(){
     // Ya no bloqueamos el botón; sólo marcamos estado interno
     if(!addBtn) return;
     addBtn.classList.add('needs-size');
     addBtn.disabled = false;
     addBtn.setAttribute('aria-disabled','false');
    }

    function getChosenColor(){
      const b = $('.celestPdp__swatch.is-active', swWrap);
      return b ? b.dataset.value : null;
    }
    function getChosenSize(){
      const act = $('.celestPdp__size.is-active', sizeWrap);
      if(act) return act.dataset.value;
      if(sizeBtn?.dataset.value) return sizeBtn.dataset.value;
      return null;
    }

    function findVariantBy(colorVal, sizeVal){
      let pool = variants.slice();
      if(colorIndex>=0 && colorVal){
        pool = pool.filter(v => norm(v.options[colorIndex]) === norm(colorVal));
      }
      if(sizeIndex>=0 && sizeVal){
        pool = pool.filter(v => norm(v.options[sizeIndex]) === norm(sizeVal));
      }
      let v = pool.find(x=>x.available) || pool[0] || null;
      if(!v && (colorVal || sizeVal)){
        if(colorVal && colorIndex>=0){
          v = variants.filter(x=>norm(x.options[colorIndex])===norm(colorVal)).find(x=>x.available) ||
              variants.find(x=>norm(x.options[colorIndex])===norm(colorVal));
        }
        if(!v && sizeVal && sizeIndex>=0){
          v = variants.filter(x=>norm(x.options[sizeIndex])===norm(sizeVal)).find(x=>x.available) ||
              variants.find(x=>norm(x.options[sizeIndex])===norm(sizeVal));
        }
      }
      return v || selectedVariant;
    }
    function nudgeSizesRow(){
  const row = sizeWrap?.closest('.celestPdp__sizeWrap') || sizeWrap;
  if(!row) return;

  row.classList.remove('is-error');
  void row.offsetWidth;
  row.classList.add('is-error');

  try{ if('vibrate' in navigator) navigator.vibrate([70,40,70]); }catch(_){}
  row.scrollIntoView({block:'center', behavior:'smooth'});
  setTimeout(()=> row.classList.remove('is-error'), 800);
}


    function updateSelectedVariantFromUI(){
     const col = getChosenColor();
     const siz = getChosenSize();

     // Si el producto tiene talla y aún no se eligió, no fijamos variante
     if(hasSizeUI && !siz){
     selectedVariant = null;
     if(idInput) idInput.value = '';
     return;
    }

     selectedVariant = findVariantBy(col, siz);
     if(idInput && selectedVariant) idInput.value = selectedVariant.id;
    }


     /* El CTA queda siempre “clickable”; marcamos si falta talla */
     function refreshCTA(){
     if(!addBtn) return;
     const siz = getChosenSize();
     const needs = hasSizeUI && !siz;
     addBtn.classList.toggle('needs-size', needs);
     sizeBtn?.classList.toggle('has-selection', !!siz);
    }

    /* ===== Swatches color ===== */
    function preselectFirstColor(){
      if(!swWrap) return;
      if($('.celestPdp__swatch.is-active', swWrap)) return;
      const first = $('.celestPdp__swatch:not(.is-disabled)', swWrap) || $('.celestPdp__swatch', swWrap);
      if(first){
        $$('.celestPdp__swatch', swWrap).forEach(x=>x.classList.remove('is-active'));
        first.classList.add('is-active');
        if(colorLbl) colorLbl.textContent = first.dataset.value || '';
      }
    }
 




    /* ===== Guía de tallas ===== */
    function openGuide(){ if(!guideWrap) return; guideWrap.hidden=false; requestAnimationFrame(()=>guideBody?.classList.add('is-open')); if(isMobile.matches) document.body.style.overflow='hidden'; }
    function closeGuide(){ if(!guideWrap || guideWrap.hidden) return; guideBody?.classList.remove('is-open'); guideBody?.addEventListener('transitionend',()=>{ guideWrap.hidden=true; },{once:true}); document.body.style.overflow=''; }
    root.addEventListener('click', (e)=>{
      if(e.target.closest('.js-openGuide')){ e.preventDefault(); closeSizes(); openGuide(); }
      if(e.target.closest('.celestPdp__guideClose')){ closeGuide(); }
      if(e.target===guideWrap){ closeGuide(); }
      if(e.target.closest('.celestPdp__addBtn')){ closeSizes(); }
    });

  /* ===== Galería: barra + contador (con anti-rebote móvil + soporte de FILTRADO por color) ===== */
function visibleSlides(){
  const root = document.getElementById('celest-mobile-pdp');
  const cel = Array.from(root.querySelectorAll('.celestPdp__slide'));
  if(cel.length) return cel.filter(s=>s.style.display!=='none' && !s.classList.contains('is-hidden'));
  const slidesEl = root.querySelector('#celestSlides, .celestPdp__slides, .product__media-list');
  const theme = slidesEl ? Array.from(slidesEl.querySelectorAll('.product__media-item, [data-media-id], .swiper-slide, .flickity-slider > *')) : [];
  return theme.length ? theme.filter(s=>s.style.display!=='none' && !s.classList.contains('is-hidden')) : [];
}

(function setupGalleryBarAndCounter(){
  const root = document.getElementById('celest-mobile-pdp');
  if(!root) return;

  const isMobile   = matchMedia('(max-width: 989px)');
  const slidesEl   = root.querySelector('#celestSlides, .celestPdp__slides, .product__media-list');
  const progressBar= root.querySelector('.celestPdp__progressBar');
  const currentEl  = root.querySelector('.celestPdp__counter .js-current');
  const totalEl    = root.querySelector('.celestPdp__counter .js-total');

  function setCounter(i,t){ if(currentEl) currentEl.textContent=i; if(totalEl) totalEl.textContent=t; }

  function updateByScroll(){
    if(!slidesEl) return;
    const vis = visibleSlides(); const total = Math.max(1, vis.length);
    const vw = slidesEl.getBoundingClientRect().width || 1;
    const idx = Math.min(total, Math.max(1, Math.round(slidesEl.scrollLeft / vw) + 1));
    if(progressBar) progressBar.style.width = (idx/total*100)+'%';
    setCounter(idx,total);
  }

  function observeCounter(){
    if(!slidesEl) return;
    const vis = visibleSlides(); if(!vis.length) return;
    const map = new Map(vis.map((el,i)=>[el,i]));
    const io = new IntersectionObserver((entries)=>{
      let best=null;
      for(const en of entries){ if(en.isIntersecting){ if(!best || en.intersectionRatio>best.intersectionRatio) best=en; } }
      if(best){
        const i=(map.get(best.target)||0)+1, t=vis.length;
        if(progressBar) progressBar.style.width = (i/t*100)+'%';
        setCounter(i,t);
      }
    },{root:slidesEl, threshold:[0.6]});
    vis.forEach(el=>io.observe(el));
  }

  // ---- Anti-rebote móvil (evita que “tire” de la página al llegar a los extremos) ----
  function installOverscrollGuard(){
    if(!slidesEl || !isMobile.matches) return;

    slidesEl.style.overscrollBehaviorX = 'contain';
    slidesEl.style.webkitOverflowScrolling = 'touch';
    slidesEl.style.touchAction = 'pan-y';

    let startX=0, startY=0, active=false, isH=false;

    slidesEl.addEventListener('touchstart', (e)=>{
      if(e.touches.length!==1) return;
      active=true; isH=false;
      startX=e.touches[0].clientX;
      startY=e.touches[0].clientY;
    }, {passive:true});

    slidesEl.addEventListener('touchmove', (e)=>{
      if(!active) return;
      const x=e.touches[0].clientX, y=e.touches[0].clientY;
      const dx=x-startX, dy=y-startY;

      if(!isH && Math.abs(dx)>10 && Math.abs(dx)>Math.abs(dy)) isH=true;

      if(isH){
        const atStart = slidesEl.scrollLeft <= 0;
        const atEnd   = Math.ceil(slidesEl.scrollLeft + slidesEl.clientWidth) >= slidesEl.scrollWidth;
        if ((atStart && dx>0) || (atEnd && dx<0)){
          e.preventDefault();
          e.stopPropagation();
          slidesEl.scrollLeft = atStart ? 0 : (slidesEl.scrollWidth - slidesEl.clientWidth);
        }
      }
    }, {passive:false});

    slidesEl.addEventListener('touchend', ()=>{ active=false; isH=false; }, {passive:true});
    slidesEl.addEventListener('touchcancel', ()=>{ active=false; isH=false; }, {passive:true});
  }

  slidesEl?.addEventListener('scroll', ()=>requestAnimationFrame(updateByScroll), {passive:true});
  slidesEl?.addEventListener('touchmove', ()=>requestAnimationFrame(updateByScroll), {passive:true});
  slidesEl?.addEventListener('touchend', updateByScroll, {passive:true});
  window.addEventListener('resize', updateByScroll);

  // 🔁 Recalcular cuando la lista visible cambie (tras filtrar por color)
  root.addEventListener('celest:gallery:filtered', ()=>{
    // Lleva el carrusel al inicio para evitar índices fuera de rango
    if (slidesEl && typeof slidesEl.scrollTo==='function') slidesEl.scrollTo({left:0, behavior:'instant'});
    observeCounter();
    updateByScroll();
  });

  observeCounter();
  updateByScroll();
  installOverscrollGuard();
})();


/* ===== Mini-cart LV (sin cambios de lógica, solo mostramos propiedades) ===== */
    const cartModal   = $('.celestPdp__cartModal', root);
    const cartBodyEl  = $('.celestPdp__cartBody', root);
    const cartTitleEl = $('.celestPdp__cartTitle', root);
    const cartItems   = $('.js-cartItems', root);
    const upsellSlot  = $('.celestPdp__upsellSlot', root);
    
    const subtotalEl  = $('.js-subtotal', root);
    const shipTextEl  = $('.js-shipText', root);
    const shipBarEl   = $('.js-shipBar', root);
   
/* ============================
   CELEST • Discount UI (mini-cart) — FIX v2 (chip X no se pega)
============================ */
let discUI = {
  wrap: null,
  toggleBtn: null,
  panel: null,
  input: null,
  applyBtn: null,
  closeLine: null,
  error: null,
  chip: null,
  chipX: null,
  _clearing: false
};

/* --- Cookies helpers (fallback) --- */
function celestGetCookie(name){
  try{
    const m = document.cookie.match(new RegExp('(^|;\\s*)' + name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g,'\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[2]) : '';
  }catch(_){ return ''; }
}
function celestDeleteCookie(name){
  try{
    const host = location.hostname;
    const parts = host.split('.');
    const domains = [
      null,
      host,
      '.' + host,
      parts.length > 2 ? '.' + parts.slice(-2).join('.') : null
    ].filter(Boolean);

    document.cookie = `${name}=; Max-Age=0; path=/;`;
    domains.forEach(d=>{
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${d};`;
    });
  }catch(_){}
}
function celestClearDiscountPersist(){
  // tu storage (si lo usas en otra parte)
  try{ localStorage.removeItem('celest_discount_code'); }catch(_){}

  // cookies típicas + cualquiera que empiece con discount
  try{
    ['discount_code','discount','discounts','shopify_discount','shopify_discounts','cart_discount','checkout_discount_code']
      .forEach(celestDeleteCookie);

    document.cookie.split(';').forEach(c=>{
      const n = (c.split('=')[0]||'').trim();
      if(n && n.toLowerCase().startsWith('discount')) celestDeleteCookie(n);
    });
  }catch(_){}
}

/* --- clear real con iframe (fetch no siempre limpia) --- */
function celestCartHasDiscount(cart){
  try{
    if (!cart) return false;

    // Señal más confiable en cart.js
    if (typeof cart.total_discount === 'number' && cart.total_discount > 0) return true;

    // Fallbacks (por si total_discount viene raro)
    if (typeof cart.items_subtotal_price === 'number' && typeof cart.total_price === 'number' && cart.items_subtotal_price > cart.total_price) return true;

    const items = cart.items || [];
    return items.some(it =>
      (it.line_level_discount_allocations && it.line_level_discount_allocations.length) ||
      (it.discount_allocations && it.discount_allocations.length)
    );
  }catch(_){ return false; }
}

// Intento “soft” (sin recargar)
async function celestClearViaSoft(){
  try{
    // 1) fetch (a veces funciona)
    await fetch(`/discount/clear?redirect=/cart&t=${Date.now()}`, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    });
  }catch(_){}

  // 2) iframe (si el server lo permite)
  try{
    await new Promise((resolve)=>{
      const ifr = document.createElement('iframe');
      ifr.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
      const url = `/discount/clear?redirect=/cart&t=${Date.now()}`;

      let doneCalled = false;
      const done = ()=>{ if(doneCalled) return; doneCalled = true; try{ ifr.remove(); }catch(_){} resolve(true); };

      ifr.onload = ()=> setTimeout(done, 180);
      ifr.src = url;
      document.body.appendChild(ifr);
      setTimeout(done, 1200);
    });
  }catch(_){}
}

// Fallback “hard” (GARANTIZA que Shopify lo quite)
function celestClearViaHardNavigate(){
  try{
    // volver a la misma URL (sin dominio)
    const returnTo = location.pathname + location.search + location.hash;

    // bandera para reabrir el mini-cart al volver
    sessionStorage.setItem('celest_after_clear_discount_open_cart', '1');

    // navegación real (esto sí limpia el descuento en Shopify)
    location.href = `/discount/clear?redirect=${encodeURIComponent(returnTo)}`;
  }catch(_){
    location.href = `/discount/clear?redirect=/cart`;
  }
}


function ensureDiscountUI(){
  if (discUI.wrap) return;

  // Lo montamos dentro del footer (si existe) o lo creamos con tu lógica
  let footer = $('.celestPdp__cartFooter', root);
  if (!footer && cartBodyEl) {
    footer = document.createElement('div');
    footer.className = 'celestPdp__cartFooter';
    cartBodyEl.appendChild(footer);
  }

  discUI.wrap = document.createElement('div');
  discUI.wrap.className = 'celestPdp__discountWrap';

  discUI.wrap.innerHTML = `
    <button type="button" class="celestPdp__discToggle" aria-expanded="false">
      <span class="celestPdp__discIcon" aria-hidden="true">+</span>
      <span class="celestPdp__discToggleText">Añadir descuento</span>
    </button>

    <div class="celestPdp__discPanel" aria-hidden="true">
      <div class="celestPdp__discCloseLine" role="button" tabindex="0">
        <span class="celestPdp__discIcon" aria-hidden="true">×</span>
        <span class="celestPdp__discToggleText">Cerrar</span>
      </div>

      <div class="celestPdp__discRow">
        <input class="celestPdp__discInput" type="text" inputmode="text" autocomplete="off"
               placeholder="Código de descuento" />
        <button type="button" class="celestPdp__discApply">APLICAR</button>
      </div>

      <div class="celestPdp__discError"></div>
    </div>

    <div class="celestPdp__discChip" hidden>
      <span class="celestPdp__discChipText"></span>
      <button type="button" class="js-clearDiscount" aria-label="Quitar cupón">
  <span class="celestDiscChipX__x" aria-hidden="true">×</span>
  <span class="celestDiscChipX__spinner" aria-hidden="true"></span>
</button>
    </div>
  `;

  // Insertar arriba del subtotal para que se vea como tu screenshot
  const subtotalRow = $('.celestPdp__cartSubtotal', root);
  if (subtotalRow && subtotalRow.parentNode) {
    subtotalRow.parentNode.insertBefore(discUI.wrap, subtotalRow);
  } else {
    footer.appendChild(discUI.wrap);
  }

  discUI.toggleBtn = discUI.wrap.querySelector('.celestPdp__discToggle');
  discUI.panel     = discUI.wrap.querySelector('.celestPdp__discPanel');
  discUI.input     = discUI.wrap.querySelector('.celestPdp__discInput');
  discUI.applyBtn  = discUI.wrap.querySelector('.celestPdp__discApply');
  discUI.closeLine = discUI.wrap.querySelector('.celestPdp__discCloseLine');
  discUI.error     = discUI.wrap.querySelector('.celestPdp__discError');
  discUI.chip      = discUI.wrap.querySelector('.celestPdp__discChip');
  discUI.chipX     = discUI.chip.querySelector('button');
function setChipXLoading(on){
  if(!discUI.chipX) return;
  discUI.chipX.classList.toggle('is-loading', !!on);
  discUI.chipX.disabled = !!on;
  discUI.chipX.setAttribute('aria-disabled', on ? 'true' : 'false');
}
discUI._setChipXLoading = setChipXLoading;

  function setOpen(open){
    if (!discUI.panel || !discUI.toggleBtn) return;

    discUI.panel.classList.toggle('is-open', !!open);
    discUI.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    discUI.panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    discUI.toggleBtn.hidden = !!open;

    // 👇 IMPORTANTE: el toggle NO cambia a "Cerrar"
    const icon = discUI.toggleBtn.querySelector('.celestPdp__discIcon');
    const txt  = discUI.toggleBtn.querySelector('.celestPdp__discToggleText');
    if (icon) icon.textContent = '+';
    if (txt)  txt.textContent  = 'Añadir descuento';
  }

  function setError(msg){
    if (!discUI.error) return;
    if (!msg){
      discUI.error.classList.remove('is-show');
      discUI.error.textContent = '';
      return;
    }
    discUI.error.textContent = msg;
    discUI.error.classList.add('is-show');
  }

  async function fetchCart(){
    return fetch('/cart.js', { headers:{'Accept':'application/json'}, credentials:'same-origin' }).then(r=>r.json());
  }

  function getDiscountApplications(cart){
    return cart?.cart_level_discount_applications || cart?.discount_applications || [];
  }

  function findAppliedCode(cart){
    const apps = getDiscountApplications(cart);
    if (!apps || !apps.length) return null;

    const codeApp = apps.find(a => (a.type||'').toLowerCase() === 'discount_code');
    if (codeApp && codeApp.title) return codeApp.title;

    return apps[0]?.title || null;
  }

  async function applyDiscount(code){
    code = String(code||'').trim();
    if (!code) return;

    setError('');
    discUI.applyBtn.disabled = true;

    try{
      // aplica por ruta nativa (setea cookie/estado) y redirige internamente
      await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`, {
        method:'GET',
        credentials:'same-origin'
      });

      const cart = await fetchCart();
      const applied = findAppliedCode(cart);

      if (!applied){
        if (discUI.input){
          discUI.input.classList.remove('is-shake');
          void discUI.input.offsetWidth;
          discUI.input.classList.add('is-shake');
        }
        try{ if('vibrate' in navigator) navigator.vibrate([60,40,60]); }catch(_){}
        setError('Código promocional incluido no válido. Puede que esté caducado, no sea compatible con otros descuentos o esté mal escrito.');
        discUI.applyBtn.disabled = false;
        return;
      }

      setOpen(false);
      discUI.input.value = '';
      setError('');

      renderMiniCart(cart);
      openCart();

    }catch(e){
      console.warn('Discount apply error', e);
      setError('No pudimos aplicar el código en este momento. Inténtalo de nuevo.');
    }finally{
      discUI.applyBtn.disabled = false;
    }
  }

async function clearDiscount() {
  if (discUI._clearing) return;
  discUI._clearing = true;

  // ✅ Mantén el chip visible y cambia la X por loader
  discUI._setChipXLoading && discUI._setChipXLoading(true);

  try {
    // 1) Elimina el descuento vía API AJAX del carrito
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: '' })
    });

    // 2) Borra cookies/localStorage de descuentos
    if (typeof celestClearDiscountPersist === 'function') {
      celestClearDiscountPersist();
    }

    // 3) Asegurar limpieza en Shopify (soft)
    if (typeof celestClearViaSoft === 'function') {
      await celestClearViaSoft();
    }

    // 4) Refrescar carrito y repintar
    const refreshedCart = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(r => r.json());

    renderMiniCart(refreshedCart);
    openCart();

    // ✅ Ahora sí: ocultar chip y mostrar “Añadir descuento”
    if (discUI.chip) discUI.chip.hidden = true;
    if (discUI.toggleBtn) discUI.toggleBtn.hidden = false;

  } catch (error) {
    console.error('Error clearing discount:', error);
    // Si falla, devolvemos la X normal (chip se queda)
  } finally {
    discUI._setChipXLoading && discUI._setChipXLoading(false);
    discUI._clearing = false;
  }
}




  // Eventos UI
  discUI.toggleBtn.addEventListener('click', ()=>{
    const open = discUI.panel.classList.contains('is-open');
    setOpen(!open);
    if (!open) setTimeout(()=>discUI.input?.focus?.(), 50);
    else setError('');
  });

  discUI.closeLine.addEventListener('click', ()=>{ setOpen(false); setError(''); });
  discUI.closeLine.addEventListener('keydown', (e)=>{ if(e.key==='Enter' || e.key===' '){ e.preventDefault(); setOpen(false); setError(''); } });

  discUI.applyBtn.addEventListener('click', ()=> applyDiscount(discUI.input.value));
  discUI.input.addEventListener('keydown', (e)=>{
    if (e.key === 'Enter'){
      e.preventDefault();
      applyDiscount(discUI.input.value);
    }
  });

  discUI.chipX.addEventListener('click', (e)=>{
    e.preventDefault();
    e.stopPropagation();
    clearDiscount();
  });

  // expone helpers para render
  discUI._setOpen = setOpen;
  discUI._setError = setError;
  discUI._findAppliedCode = findAppliedCode;
}

function renderDiscountUIFromCart(cart){
  ensureDiscountUI();
  if (!discUI.wrap) return;

  const code = discUI._findAppliedCode ? discUI._findAppliedCode(cart) : null;

  if (code){
    const chipText = discUI.chip.querySelector('.celestPdp__discChipText');
    if (chipText) chipText.textContent = String(code).toUpperCase();

    discUI.chip.hidden = false;
    discUI.toggleBtn.hidden = true;
    discUI.panel.classList.remove('is-open');
    discUI.panel.setAttribute('aria-hidden','true');
    discUI.toggleBtn.setAttribute('aria-expanded','false');
    discUI._setError && discUI._setError('');
  } else {
    discUI.chip.hidden = true;
    discUI.toggleBtn.hidden = false;
    discUI._setOpen && discUI._setOpen(false);
  }
}

    let emptyTextEl = $('.celestPdp__emptyText', root);

// ✅ Si en desktop no existe el nodo, lo creamos (y lo dejamos dentro del área scroll)
if (!emptyTextEl && cartItems){
  emptyTextEl = document.createElement('div');
  emptyTextEl.className = 'celestPdp__emptyText';
  emptyTextEl.textContent = 'LA BOLSA ESTÁ VACÍA';
  emptyTextEl.style.display = 'none';           // renderMiniCart lo prende/apaga
  cartItems.insertBefore(emptyTextEl, cartItems.firstChild || null);
}

    // Aseguramos un único elemento js-etaText reutilizable
    let etaTextEl = $('.js-etaText', root);
    if (!etaTextEl) {
      // Buscamos footer del mini-cart o usamos el cuerpo como fallback
      let footer = $('.celestPdp__cartFooter', root);
      if (!footer && cartBodyEl) {
        footer = document.createElement('div');
        footer.className = 'celestPdp__cartFooter';
        cartBodyEl.appendChild(footer);
      }

      // Contenedor de mensaje de envío / ETA
      let shipBox = $('.celestPdp__shipBox', root);
      if (!shipBox) {
        shipBox = document.createElement('div');
        shipBox.className = 'celestPdp__shipBox';
        if (footer) {
          footer.insertBefore(shipBox, footer.firstChild || null);
        } else if (cartBodyEl) {
          cartBodyEl.appendChild(shipBox);
        }
      }

      // Nodo para el texto ETA (el que updateShipping usará siempre)
      etaTextEl = document.createElement('div');
      etaTextEl.className = 'celestPdp__shipText js-etaText';
      shipBox.appendChild(etaTextEl);
    }

    const closeCart   = $('.celestPdp__cartClose', root);
    const continueBtn = $('.celestPdp__continue', root);
    const checkoutBtn = $('.celestPdp__checkout', root);

  function setMiniCartTopUnderHeader(){
  if (!cartBodyEl) return;

  if (!isMobile.matches){
    // Desktop: tu top fijo, solo aseguro bottom
    cartBodyEl.style.bottom = '0';
    return;
  }

  const header = document.getElementById('celest-header') || document.querySelector('header');
  const hh = header ? Math.ceil(header.getBoundingClientRect().height) : 0;

  // 👇 el sheet ocupa TODO el alto disponible entre header y bottom
  cartBodyEl.style.position  = 'fixed';
  cartBodyEl.style.left      = '0';
  cartBodyEl.style.right     = '0';
  cartBodyEl.style.top       = `calc(${hh}px + env(safe-area-inset-top, 0px))`;
  cartBodyEl.style.bottom    = '0';

  // 🚫 NO fijes height/maxHeight aquí (top+bottom ya estiran)
  cartBodyEl.style.height    = '';
  

  document.documentElement.style.setProperty('--celestCartTop', hh + 'px');
}


function openCart(){
  if (!cartModal || !cartBodyEl) return;

  cartModal.hidden = false;

  // ✅ clase global tuya (no tocar)
  document.body.classList.add('celestCart-open');

  // ✅ posición bajo header (tu lógica)
  setMiniCartTopUnderHeader();

  // 🔥 MOBILE: arrancar “abajo” y luego subir
  if (isMobile.matches){
    cartBodyEl.classList.remove('is-open','is-closing');

    // fuerza estado inicial fuera de pantalla antes de animar
    cartBodyEl.style.transform = 'translate3d(0,110%,0)';
    // reflow
    void cartBodyEl.offsetHeight;

    requestAnimationFrame(()=>{
      cartBodyEl.style.transform = '';
      cartBodyEl.classList.add('is-open');
    });

    document.body.style.overflow='hidden';
    return;
  }

  // DESKTOP: se queda como lo tenías (sin animación)
  requestAnimationFrame(()=>cartBodyEl.classList.add('is-open'));
}

function closeCartFn(){
  if (!cartModal || !cartBodyEl) return;

  // Si ya está cerrando, no repetir
  if (cartBodyEl.dataset.closing === '1') return;
  cartBodyEl.dataset.closing = '1';

  if (isMobile.matches){
    // 🔥 MOBILE: baja suave hasta esconderse
    cartBodyEl.classList.remove('is-open');
    cartBodyEl.classList.add('is-closing');

    const done = ()=>{
      cartModal.hidden = true;
      cartBodyEl.classList.remove('is-closing');
      cartBodyEl.dataset.closing = '';
      document.body.classList.remove('celestCart-open');
      document.body.style.overflow = '';
    };

    // esperamos a que termine el transition
    cartBodyEl.addEventListener('transitionend', (e)=>{
      if (e.propertyName === 'transform') done();
    }, { once:true });

    // fallback por si no dispara transitionend
    setTimeout(done, 420);
    return;
  }

  // DESKTOP: tu cierre normal
  cartBodyEl.classList.remove('is-open');
  cartBodyEl.addEventListener('transitionend', ()=>{
    cartModal.hidden = true;
    document.body.classList.remove('celestCart-open');
    cartBodyEl.dataset.closing = '';
  }, { once:true });

  document.body.style.overflow = '';
}


    closeCart?.addEventListener('click', closeCartFn);
    continueBtn?.addEventListener('click', closeCartFn);
    cartModal?.addEventListener('click',(e)=>{
      if(e.target===cartModal && isMobile.matches) closeCartFn();
    });

    if(shipTextEl) shipTextEl.style.textAlign = 'center';
    if(etaTextEl && etaTextEl.parentElement && etaTextEl.parentElement.style){
      etaTextEl.parentElement.style.justifyContent = 'center';
    }

    function updateShipping(subtotalCents, cart){
      const threshold = Math.round(parseFloat(root.dataset.freeShippingThreshold || '300000')*100);

      // Mensaje barra envío gratis
      if(shipTextEl && shipBarEl){
        if(subtotalCents >= threshold){
          shipTextEl.textContent = 'Tu pedido cumple los requisitos de envío gratuito.';
          shipBarEl.style.width='100%';
        }else{
          const miss = threshold - subtotalCents;
          shipTextEl.textContent = `Te faltan ${fmtCOP0(miss)} para envío gratuito.`;
          shipBarEl.style.width = Math.max(2, Math.min(100, (subtotalCents/threshold)*100)) + '%';
        }
      }


      // === ETA dinámica según configuraciones del tema ===
      const minD = parseInt(root.dataset.deliveryMinDays || '3', 10);
      const maxD = parseInt(root.dataset.deliveryMaxDays || '7', 10);

      const cMin = parseInt(root.dataset.customDeliveryMinDays || '7', 10);
      const cMax = parseInt(root.dataset.customDeliveryMaxDays || '10', 10);

      // Detectar productos personalizados (propiedades visibles)
      const hasCustom = !!(cart?.items || []).some(it => {
        const props = it.properties || {};
        return Object.keys(props).some(k => {
          const key = String(k || '');
          const val = props[k];
          // ignorar claves internas tipo _is_preorder, _pz, etc.
          if (key.startsWith('_')) return false;
          return val !== null && val !== undefined && String(val).trim() !== '';
        });
      });

      if (!etaTextEl) return;

      // Base desde el tema
      let etaMsg = `🚚 Entrega estimada: <b>${minD}–${maxD} días hábiles</b> (Colombia)`;

      // Si hay personalizados, añadimos la cola usando también valores del tema
      if(hasCustom){
        etaMsg += ` — Los productos personalizados tienen una entrega estimada de <b>${cMin}–${cMax} días hábiles</b>.`;
      }

      etaTextEl.innerHTML = etaMsg;
    }

    function syncPrestige(cart){
      try{
        const count = cart?.item_count || 0;
        const selectors = [
          '[data-cart-count]','[data-cart-count-bubble]','.Header__CartCount',
          '.header__cart-count','.cart-count-bubble','.header__icon-bubble',
          '.site-header__cart-count','.js-cart-count'
        ];
        $$(selectors.join(',')).forEach(el=>{
          el.textContent = count;
          if(el.tagName==='SUP' || (el.className||'').includes('bubble')){
            el.style.display = count>0 ? '' : 'none';
          }
          if(el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', count>0 ? 'false':'true');
        });
        const detail = {cart};
        ['cart:refresh','cart:updated','prestige:cart:refresh','cart-drawer:refresh']
          .forEach(evt=>document.dispatchEvent(new CustomEvent(evt,{detail})));
      }catch(err){ console.warn('Sync Prestige failed', err); }
    }

    function changeQty(key, qty){
      const fd = new FormData(); fd.set('id', key); fd.set('quantity', Math.max(0, qty));
      fetch('/cart/change.js', {method:'POST', body:fd})
        .then(()=>fetch('/cart.js').then(r=>r.json()))
        .then(renderMiniCart)
        .catch(console.error);
    }
    /* ===== CELEST • Inline loader helpers (qty/trash) ===== */
function ensureInlineLoader(el, sizePx){
  if(!el) return null;
  const size = sizePx || 18;

  let wrap = el.querySelector('.celestInlineLoaderWrap');
  if(!wrap){
    wrap = document.createElement('span');
    wrap.className = 'celestInlineLoaderWrap';
    wrap.style.display = 'none';
    wrap.innerHTML = `<span class="celestInlineLoader" aria-hidden="true" style="width:${size}px;height:${size}px;"></span>`;
    el.appendChild(wrap);
  }
  return wrap;
}

function setInlineLoadingQty(box, on){
  if(!box) return;
  box.classList.toggle('is-loading', !!on);

  // loader en el centro del qty box
  const wrap = ensureInlineLoader(box, 16);
  if(wrap) wrap.style.display = on ? 'grid' : 'none';
}

function setInlineLoadingBtn(btn, on){
  if(!btn) return;
  btn.classList.toggle('is-loading', !!on);

  const wrap = ensureInlineLoader(btn, 18);
  if(wrap) wrap.style.display = on ? 'grid' : 'none';
}

function bindDeleteMini(container){
  if(!container) return;

  container.querySelectorAll('.celestPdp__deleteItem').forEach(btn=>{
    if(btn.__celestBound) return;
    btn.__celestBound = true;

    const key = btn.getAttribute('data-key');
    if(!key) return;

    btn.addEventListener('click', async (e)=>{
      e.preventDefault();
      e.stopPropagation();

      if(btn.classList.contains('is-loading')) return;

      setInlineLoadingBtn(btn, true);

      try{
        // remove line item
        await fetch('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      }catch(err){
        console.warn('Delete error', err);
      }finally{
        // siempre refrescar y apagar loader (sin añadir delays)
        try{
          const newCart = await fetch('/cart.js', { headers:{'Accept':'application/json'} }).then(r=>r.json());
          renderMiniCart(newCart);
        }catch(_){}
        setInlineLoadingBtn(btn, false);
      }
    });
  });
}

     function bindQtyMini(container, cartSnapshot){
  if (!container) return;

  container.querySelectorAll('.celestPdp__qtyMini').forEach(box=>{
    const key  = box.getAttribute('data-key');   // line item key
    const line = parseInt(box.getAttribute('data-line')||'0',10); // índice 1-based
    const vid  = box.getAttribute('data-vid');   // variant_id (para último fallback)
    if (!key) return;

    const minus = box.querySelector('.qMinus');
    const plus  = box.querySelector('.qPlus');
    const valEl = box.querySelector('.qVal');

    const setLoading = (on)=>{
  box.dataset.loading = on ? '1' : '';
  if(minus) minus.disabled = !!on;
  if(plus)  plus.disabled  = !!on;

  // ✅ loader inline (en el mismo lugar visual del +/−)
  setInlineLoadingQty(box, !!on);
};


    async function softFetch(url, body){
      return fetch(url, {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify(body)
      });
    }

    async function refreshCart(){
      const rc = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
      const newCart = await rc.json();
      renderMiniCart(newCart);
    }

    async function updateQty(newQty){
      setLoading(true);
      try{
        // 1) Intento estándar por KEY
        let r = await softFetch('/cart/change.js', { id: key, quantity: newQty });
        if (!r.ok){
          // 2) Fallback por LINE (cuando Shopify cambia key por stock agotado)
          if (line){
            r = await softFetch('/cart/change.js', { line: line, quantity: newQty });
          }
        }
        if (!r.ok && newQty < 1 && vid){
          // 3) Último recurso: /cart/update con variant_id (elimina TODAS las líneas de ese variant)
          await softFetch('/cart/update.js', { updates: { [vid]: 0 } });
        }
      }catch(e){
        console.warn('Qty change error', e);
      }finally{
        await refreshCart();
        setLoading(false);
      }
    }

    minus?.addEventListener('click', ()=>{
  if(box.dataset.loading === '1') return;
  const q = parseInt(valEl.textContent || '1', 10);
  updateQty(q - 1);
});

plus?.addEventListener('click', ()=>{
  if(box.dataset.loading === '1') return;
  const q = parseInt(valEl.textContent || '1', 10);
  updateQty(q + 1);
});

  });
}
function prepareCartLayout(){
  if (!cartBodyEl) return;

  // Estructura básica sólo 1 vez
  if (cartBodyEl.dataset.stickyReady !== '1'){
    cartBodyEl.dataset.stickyReady = '1';

    Object.assign(cartBodyEl.style, {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  width: '100%',
  // ✅ no maxHeight aquí; lo manda top/bottom
});


    // Sube un poco el panel bajo el header en desktop
    if (!isMobile.matches){
      cartBodyEl.style.top = '76px';
      cartBodyEl.style.borderRadius = '12px';
    }

    if (cartItems){
      cartItems.classList.add('is-scrollArea');
      Object.assign(cartItems.style, {
        flex: '1 1 auto',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        overscrollBehavior: 'contain',
        margin: '0 0 6px',
        paddingTop: '0' // el primer ítem debe pegar arriba
      });
    }
    // ✅ Meter el upsell DENTRO del área con scroll (debajo de productos y arriba del footer)
if (upsellSlot && cartItems && upsellSlot.parentNode !== cartItems){
  cartItems.appendChild(upsellSlot);
}
// ✅ Compactar espacio superior del upsell (la app suele traer márgenes)
if (upsellSlot){
  upsellSlot.style.marginTop = '0';
  upsellSlot.style.paddingTop = '0';

  const m = upsellSlot.querySelector('.celestPdp__upsellMount, .essential-upsell-cross-sell-block');
  if (m){
    m.style.marginTop = '0';
    m.style.paddingTop = '0';
  }
}


    // Footer pegajoso (subtotal + envío + acciones)
    let footer = $('.celestPdp__cartFooter', root);
    const shipBox  = $('.celestPdp__shipBox', root);
    const subtotal = $('.celestPdp__cartSubtotal', root);
    const actions  = $('.celestPdp__cartActions', root);

    if (!footer){
      footer = document.createElement('div');
      footer.className = 'celestPdp__cartFooter';
      cartBodyEl.appendChild(footer);
      Object.assign(footer.style, { position:'sticky', bottom:'0', background:'#fff' });
    }
    [shipBox, subtotal, actions].forEach(n => { if(n && n.parentNode !== footer) footer.appendChild(n); });
    // ✅ Mantener el bloque de descuento SIEMPRE visible y pegado al subtotal (en el footer)
if (discUI && discUI.wrap && footer){
  // asegúrate que exista antes de moverlo
  if (discUI.wrap.parentNode !== footer){
    // lo ponemos justo ANTES del subtotal si existe
    if (subtotal && subtotal.parentNode === footer){
      footer.insertBefore(discUI.wrap, subtotal);
    } else {
      footer.insertBefore(discUI.wrap, footer.firstChild || null);
    }
  }
}


    // Compactar espaciados
    if (shipBox){ shipBox.style.margin = '4px 0 8px'; }
    if (subtotal){ subtotal.style.padding = '6px 0'; }
    if (shipTextEl) shipTextEl.style.textAlign = 'center';
    const etaWrap = $('.celestPdp__eta', root);
    if (etaWrap){
      etaWrap.style.display = 'flex';
      etaWrap.style.justifyContent = 'center';
      etaWrap.style.textAlign = 'center';
      etaWrap.style.marginTop = '6px';
    }
  }

  // ——— Altura dinámica y padding anti-solapamiento con el footer ———
  function adjustCartLayout(){
    if (!cartItems) return;

    const count = cartItems.querySelectorAll('.celestPdp__cartItem').length;

    // Alto real del footer para no tapar el último ítem
    const footer = $('.celestPdp__cartFooter', root);
    const fh = footer ? Math.ceil(footer.getBoundingClientRect().height) : 0;
    cartItems.style.paddingBottom = (fh ? (fh + 12) : 16) + 'px';

        // Detectar si el upsell está montado con contenido
    const upsellMount = root.querySelector('.celestPdp__upsellMount');
    const upsellActive = (() => {
      if (!upsellMount) return false;
      const essential = upsellMount.querySelector('.essential-upsell-cross-sell-block');
      if (!essential) return false;
      const hasNodes = essential.children && essential.children.length > 0;
      const hasHtml  = (essential.innerHTML || '').replace(/\s+/g,'').length > 0;
      const h = essential.getBoundingClientRect ? essential.getBoundingClientRect().height : 0;
      return !!(hasNodes || hasHtml || h > 40);
    })();

    // 0 items: centrado (mensaje + upsell si aplica)
    if (count === 0){
      cartItems.style.flex      = '1 1 auto';
      cartItems.style.maxHeight = '';
      cartItems.style.minHeight = isMobile.matches ? '52vh' : '360px';
      
    }
    
else if (count === 1) {
  cartItems.style.flex      = '1 1 auto';
  cartItems.style.maxHeight = '';

  // Detectar si la única línea tiene descuento
  const hasDiscount = !!cartItems.querySelector('.celestCartPrice--old, .celestCartTag--discount, .celestCart__discountInfo');

  if (upsellActive) {
    // Si hay descuento: subir casi toda la ventana
    if (hasDiscount) {
      
      cartItems.style.minHeight  = isMobile.matches ? '80vh'  : '550px';
    } else {
      // Sin descuento: subir bastante, pero no tanto
      
      cartItems.style.minHeight  = isMobile.matches ? '90vh' : '650px';
    }
  } else {
    // Sin upsell → alturas base para 1 producto
    cartItems.style.minHeight  = isMobile.matches ? '60vh' : '420px';
    
  }
}




    // Dos ítems
    else if (count === 2){
      cartItems.style.flex      = '1 1 auto';
      cartItems.style.maxHeight = isMobile.matches ? '56vh' : '44vh';
      cartItems.style.minHeight = '300px';
      
    }
    // Tres o más
    else{
      cartItems.style.flex      = '1 1 auto';
      cartItems.style.maxHeight = isMobile.matches ? '66vh' : '60vh';
      cartItems.style.minHeight = '360px';
      
    }

  }

  // Ajuste inicial
  adjustCartLayout();

  // Observar cambios de items (añadir/quitar/cambiar qty)
  if (!cartBodyEl._celestCartMO && cartItems){
    const mo = new MutationObserver(adjustCartLayout);
    mo.observe(cartItems, { childList:true });
    cartBodyEl._celestCartMO = mo;

    // Por si el tema re-renderiza el footer
    const mo2 = new MutationObserver(adjustCartLayout);
    const footer = $('.celestPdp__cartFooter', root);
    if (footer) mo2.observe(footer, { childList:true, subtree:true });
    cartBodyEl._celestCartFooterMO = mo2;
  }

  // Recalcular al cambiar tamaño de viewport
  window.addEventListener('resize', adjustCartLayout, { passive:true });
}

function renderMiniCart(cart){
  if (!cart || !cartItems) return;

  const items = cart.items || [];
  const hasPO = items.some(it => (it.properties||{})._is_preorder === '1');
    // --- Descuentos a nivel de pedido (ej: "50% al total desde $500.000") ---
  const cartLevelApps =
    cart.cart_level_discount_applications ||
    cart.discount_applications ||
    [];

  const hasCartLevelDiscount = cartLevelApps.length > 0;

  // ¿Alguna línea ya trae descuentos propios (buy X get Y, % por producto, etc.)?
  const anyLineHasDiscount = items.some(li =>
    (li.line_level_discount_allocations && li.line_level_discount_allocations.length) ||
    (li.discount_allocations && li.discount_allocations.length)
  );

  let globalDiscPct   = 0;
  let globalDiscTitle = null;

  if (hasCartLevelDiscount && cart.items_subtotal_price > 0) {
    const diff = Math.max(0, (cart.items_subtotal_price - cart.total_price));
    if (diff > 0) {
      globalDiscPct   = Math.round(diff * 100 / cart.items_subtotal_price);
      globalDiscTitle = (cartLevelApps[0] && cartLevelApps[0].title) || null;
    }
  }

  // Solo aplicamos el % global a cada línea cuando:
  // - hay descuento de pedido
  // - y NINGUNA línea trae sus propios discounts (para no pisar buy X get Y, etc.)
  const shouldApplyGlobalPerLine = globalDiscPct > 0 && !anyLineHasDiscount;

  const hasOnlyPO = hasPO && items.every(it => (it.properties||{})._is_preorder === '1');

  if (cartTitleEl) cartTitleEl.textContent = `Añadido a la bolsa (${cart.item_count || 0})`;

ensureDiscountUI();

prepareCartLayout();


  // --- Aviso Pre-orden (SOLO MÓVIL)
  let poNotice = root.querySelector('.celestPdp__poNotice');
  if (!poNotice){
    poNotice = document.createElement('div');
    poNotice.className = 'celestPdp__poNotice';
    poNotice.style.cssText = 'margin:10px 0 8px;padding:12px 14px;border-radius:12px;background:#fff3cd;color:#7a5c00;font-weight:600;';
    poNotice.hidden = true;
    cartBodyEl.insertBefore(poNotice, cartItems);
  }

  // mostrar solo en móvil (≤989px)
  const showOnMobile = isMobile.matches && hasPO;
  if (showOnMobile){
    poNotice.innerHTML = 'Tienes artículos de <b>Pre-orden</b> en tu carrito que solo serán enviados el día de su lanzamiento.';
    poNotice.hidden = false;
  } else {
    poNotice.hidden = true;
  }

  // si cambia el viewport, re-evaluamos (evitamos múltiples listeners)
  if (!poNotice.dataset.boundResize){
    poNotice.dataset.boundResize = '1';
    const reevaluateNotice = () => {
      const mql = matchMedia('(max-width: 989px)');
      const onlyMobile = mql.matches && hasPO;
      poNotice.hidden = !onlyMobile;
    };
    window.addEventListener('resize', reevaluateNotice, { passive:true });
  }

  // Mostrar/ocultar Envío y ETA (solo-pre-orden => oculto)
  const shipBoxEl = root.querySelector('.celestPdp__shipBox');
  const etaWrapEl = root.querySelector('.celestPdp__eta')?.parentElement || root.querySelector('.celestPdp__eta');
  if (hasOnlyPO){
    if (shipBoxEl) shipBoxEl.style.display = 'none';
    if (etaWrapEl) etaWrapEl.style.display = 'none';
  } else {
    if (shipBoxEl) shipBoxEl.style.display = '';
    if (etaWrapEl) etaWrapEl.style.display = '';
  }

  // --- Items
// 1) Desmontar upsellSlot antes de limpiar (evita que innerHTML lo destruya)
if (upsellSlot && upsellSlot.parentNode){
  upsellSlot.parentNode.removeChild(upsellSlot);
}

// 2) Guardar el emptyTextEl si existe (porque innerHTML lo mata)
if (emptyTextEl && emptyTextEl.parentNode){
  emptyTextEl.parentNode.removeChild(emptyTextEl);
}

cartItems.innerHTML = '';

// 3) Reinsertar emptyTextEl SIEMPRE como primer hijo del área scroll
if (emptyTextEl){
  cartItems.insertBefore(emptyTextEl, cartItems.firstChild || null);
}

// 4) Render real de items (ESTE es el único forEach que debe quedar)
items.forEach((it, idx)=>{
  const props = it.properties || {};
  const isPO  = props._is_preorder === '1';

  // “Gratis” / regalo via properties manuales
  const isGiftFlag =
    props._is_gift === '1' ||
    String(props['Gratis'] || '').toLowerCase() === 'true' ||
    String(props['Gratis'] || '').toLowerCase() === 'sí';

  // PERSONALIZADO (detección robusta desde properties del line item)
  const anyText = v => v !== undefined && String(v).trim() !== '';
  const keysLC = Object.keys(props).map(k => k.toLowerCase());
  const hasPersonalizado =
    props._is_personalizable === '1' || props._pz === '1' || props._pz_config ||
    anyText(props['_pz_price_text']) || anyText(props['_pz_letters']) || anyText(props['_pz_color']) ||
    anyText(props['Personalización']) || anyText(props['Personalizado']) ||
    anyText(props['Letras']) || anyText(props['Iniciales']) || anyText(props['Monograma']) ||
    anyText(props['Color']) || (props['Puntos'] !== undefined && props['Puntos'] !== null && `${props['Puntos']}` !== '') ||
    keysLC.some(k => k.includes('personaliz') || k.includes('monogram') || k.includes('inicial'));

  const div = document.createElement('div');
  div.className = 'celestPdp__cartItem';

  const img  = it.image ? `<img src="${it.image}" alt="${it.product_title}">` : '<div class="celestPdp__imgPh"></div>';
  const opts = (it.options_with_values||[]).map(o=>`${o.name}: ${o.value}`).join(' · ');
  const qty  = it.quantity || 1;

  /* ========= PRECIOS CON DESCUENTO (robusto) =========
     1) Intentamos usar las properties guardadas al añadir:
        _cel_price_cents y _cel_compare_cents (unitarios, en centavos)
     2) Si no existen, usamos product.variants (solo para la PDP actual)
     3) Tomamos SIEMPRE los valores finales de /cart.js cuando hay descuentos
     4) Último fallback: campos de /cart.js sin descuentos
  ---------------------------------------------------- */
  const propPriceCents   = parseInt(props._cel_price_cents   || props._cel_price   || '', 10);
  const propCompareCents = parseInt(props._cel_compare_cents || props._cel_compare || '', 10);

  let regularCents = 0;
  let finalCents   = 0;

  // 1) Base: properties guardadas (más fiables para precio base)
  if (!isNaN(propPriceCents)) {
    const unitPrice   = propPriceCents;
    const unitCompare = (!isNaN(propCompareCents) && propCompareCents > unitPrice)
      ? propCompareCents
      : unitPrice;

    regularCents = unitCompare * qty;
    finalCents   = unitPrice   * qty;
  } else {
    // 2) Intentar desde el JSON de producto de esta PDP (variable `product` definida arriba)
    let unitRegular = null;
    let unitFinal   = null;

    if (product && Array.isArray(product.variants)) {
      const v = product.variants.find(v => String(v.id) === String(it.variant_id));
      if (v) {
        unitFinal   = typeof v.price === 'number' ? v.price : null;
        const base  = (typeof v.compare_at_price === 'number' && v.compare_at_price > 0)
                    ? v.compare_at_price
                    : unitFinal;
        unitRegular = base;
      }
    }

    if (unitRegular != null && unitFinal != null) {
      regularCents = unitRegular * qty;
      finalCents   = unitFinal   * qty;
    }
  }

  // 3) Descuentos automáticos de Shopify (cupones, buy X get Y, etc.)
  const lineDiscounts = it.line_level_discount_allocations || [];
  let autoDiscCents   = 0;
  let autoDiscTitle   = null;

  lineDiscounts.forEach(d => {
    // amount normalmente viene en centavos en /cart.js
    let a = 0;
    if (typeof d.amount === 'number') {
      a = d.amount;
    } else if (typeof d.amount === 'string') {
      // asume centavos; si Shopify lo manda en moneda, el resultado seguirá siendo coherente en %
      a = Math.round(parseFloat(d.amount.replace(',', '.')) || 0);
    }
    autoDiscCents += a;
    if (!autoDiscTitle && d.discount_application && d.discount_application.title) {
      autoDiscTitle = d.discount_application.title;
    }
  });

  // Tomar SIEMPRE el final_line_price del carrito cuando exista
  if (typeof it.final_line_price === 'number') {
    finalCents = it.final_line_price;
  } else if (!finalCents) {
    finalCents = it.line_price || 0;
  }

  // Reconstruir precio original si hace falta
  if (!regularCents) {
    if (typeof it.original_line_price === 'number' && it.original_line_price > 0) {
      regularCents = it.original_line_price;
    } else if (autoDiscCents > 0) {
      regularCents = finalCents + autoDiscCents;
    } else {
      regularCents = finalCents;
    }
  } else if (autoDiscCents > 0 && regularCents < finalCents + autoDiscCents) {
    // Aseguramos coherencia cuando el carrito reparte descuentos
    regularCents = finalCents + autoDiscCents;
  }

  /* 🔥 NUEVO BLOQUE PARA DESCUENTOS POR MONTO TOTAL 🔥
     (se mantiene tal cual lo tenías arriba en tu renderMiniCart)
  --------------------------------------------------------------- */
  if (typeof shouldApplyGlobalPerLine !== 'undefined' && shouldApplyGlobalPerLine) {
    const base = regularCents ||
                 (typeof it.original_line_price === 'number' && it.original_line_price > 0
                   ? it.original_line_price
                   : (it.line_price || it.final_line_price || 0));

    if (base > 0) {
      const discounted = Math.round(base * (100 - globalDiscPct) / 100);

      if (discounted < base) {
        regularCents  = base;
        finalCents    = discounted;
        autoDiscCents = base - discounted;

        if (!autoDiscTitle && globalDiscTitle) {
          autoDiscTitle = globalDiscTitle;
        }
      }
    }
  }

  // Flags finales
  const hasAutoDiscount  = autoDiscCents > 0;
  const hasPriceDiscount = regularCents > finalCents && regularCents > 0;

  // === Precio + pildoras junto al precio ===
  let priceHtml = '';
  if (hasPriceDiscount) {
    const diff = regularCents - finalCents;
    const pct  = regularCents > 0 ? Math.round(diff * 100 / regularCents) : 0;

    const isFreeByDiscount = finalCents <= 0 || pct >= 100;
    const pctLabel = isFreeByDiscount ? 'Gratis' : `${pct}% de descuento`;

    const tagClass = isFreeByDiscount ? 'celestCartTag--gift' : 'celestCartTag--discount';
    const tagText  = isFreeByDiscount ? 'GRATIS' : pctLabel;

    priceHtml = `
      <span class="celestCartPrice celestCartPrice--old">
        ${fmtCOP0(regularCents)}
      </span>
      <span class="celestCartPrice celestCartPrice--new">
        ${fmtCOP0(Math.max(0, finalCents))}
      </span>
      <span class="celestCartTag ${tagClass}">
        ${tagText}
      </span>
    `;
  } else {
    // Sin descuento → solo precio normal
    priceHtml = `
      <span class="celestCartPrice celestCartPrice--new">
        ${fmtCOP0(finalCents || regularCents || 0)}
      </span>
    `;
    // Si viene marcado como regalo manual, añadimos pildora GRATIS aunque no haya cupón
    if (isGiftFlag) {
      priceHtml += `
        <span class="celestCartTag celestCartTag--gift">
          GRATIS
        </span>
      `;
    }
  }

  // === Badge / línea de INFO de descuento (solo nombre del cupón) ===
  let discountInfoHtml = '';
  if (hasAutoDiscount && autoDiscTitle) {
    discountInfoHtml = `
      <div class="celestCart__discountInfo">
        <span class="celestCart__discountIcon" aria-hidden="true">🏷️</span>
        <span class="celestCart__discountText">
          Descuento aplicado · ${autoDiscTitle}
        </span>
      </div>
    `;
  }

  // === Pildoras cerca del título (Pre-orden / Personalizado) ===
  const titleBadges = [];
  if (isPO)             titleBadges.push('<span class="celestBadge">Pre-orden</span>');
  if (hasPersonalizado) titleBadges.push('<span class="celestBadge">Personalizado</span>');

  let titleHtml = it.product_title || '';
  if (titleBadges.length) {
    titleHtml += ` <span class="celestCart__titleDash">-</span> ${titleBadges.join(' ')}`;
  }

  // Detalle de personalización (si aplica)
  let pzHtml = '';
  if(hasPersonalizado){
    const parts = [];
    if(anyText(props['Letras']))    parts.push(`Letras: ${props['Letras']}`);
    if(anyText(props['Iniciales'])) parts.push(`Iniciales: ${props['Iniciales']}`);
    if(anyText(props['Monograma'])) parts.push(`Monograma: ${props['Monograma']}`);
    if(anyText(props['Color']))     parts.push(`Color: ${props['Color']}`);
    if(props['Puntos'] !== undefined && props['Puntos'] !== null && `${props['Puntos']}` !== '') parts.push(`Puntos: ${props['Puntos']}`);
    const priceText = anyText(props['_pz_price_text']) ? ` · ${props['_pz_price_text']}` : '';
    const label = props['Personalización'] ? 'Personalización' : (props['Personalizado'] ? 'Personalizado' : 'Personalización');
    if (parts.length || priceText){
      pzHtml = `<div class="celestPdp__opts" style="margin-top:4px;">${label}: ${parts.join(' · ')}${priceText}</div>`;
    }
  }

  div.innerHTML = `
    <div class="celestPdp__itemLeft">${img}</div>

    <div class="celestPdp__itemRight">
      <div class="t1 celestPdp__title">${titleHtml}</div>
      <div class="t2 celestPdp__opts">${opts || ''}</div>
      ${pzHtml}
      <div class="t3 celestPdp__price">${priceHtml}</div>
      ${discountInfoHtml}

      <div class="celestPdp__qtyAndDelete">
        <div class="celestPdp__qtyMini"
             data-key="${it.key}"
             data-line="${idx+1}"
             data-vid="${it.variant_id}">
          <button type="button" class="qMinus" aria-label="Disminuir">−</button>
          <span class="qVal">${it.quantity}</span>
          <button type="button" class="qPlus" aria-label="Aumentar">+</button>
        </div>

        <button class="celestPdp__deleteItem"
                data-key="${it.key}"
                aria-label="Eliminar producto">
          <svg viewBox="0 0 24 24" width="22" height="22">
            <path d="M3 6h18M10 6V4h4v2m-7 3h10l-1 11H7L6 9z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  `;

  cartItems.appendChild(div);
});

// ✅ Reinsertar upsellSlot al final de la lista (siempre debajo de productos)
// (si no hay items, quedará centrado por CSS con .is-empty)
if (upsellSlot && cartItems){
  cartItems.appendChild(upsellSlot);
  upsellSlot.hidden = false;
}

// ✅ Estado vacío (centrado + ocultar info)
const isEmpty = !items || items.length === 0;

// Toggle clase para el CSS de centrado
cartItems.classList.toggle('is-empty', !!isEmpty);

// Mostrar/ocultar texto “LA CESTA ESTÁ VACÍA”
if (emptyTextEl){
  emptyTextEl.style.display = isEmpty ? '' : 'none';
}
// Ocultar / mostrar descuento según carrito vacío
if (discUI && discUI.wrap) {
  discUI.wrap.style.display = isEmpty ? 'none' : '';
}


// Ocultar bloque informativo cuando está vacío (para que quede realmente centrado)
const shipBoxEl2  = root.querySelector('.celestPdp__shipBox');
const subtotalRow = root.querySelector('.celestPdp__cartSubtotal');
const actionsRow  = root.querySelector('.celestPdp__cartActions');
if (shipBoxEl2)  shipBoxEl2.style.display  = isEmpty ? 'none' : '';
if (subtotalRow) subtotalRow.style.display = isEmpty ? 'none' : '';
if (actionsRow)  actionsRow.style.display  = isEmpty ? 'none' : '';


     // Subtotal mostrado = total del carrito DESPUÉS de todos los descuentos
// + si hay descuento: muestra "antes" tachado y "después" normal
if (subtotalEl) {
  const totalCents = (typeof cart.total_price === 'number' && cart.total_price >= 0)
    ? cart.total_price
    : (cart.items_subtotal_price || 0);

  const beforeCents = (typeof cart.items_subtotal_price === 'number')
    ? cart.items_subtotal_price
    : totalCents;

  if (beforeCents > totalCents) {
    subtotalEl.innerHTML = `
      <span class="celestPdp__subtotalOld">${fmtCOP0(beforeCents)}</span>
      <span class="celestPdp__subtotalNew">${fmtCOP0(totalCents)}</span>
    `.trim();
  } else {
    subtotalEl.textContent = fmtCOP0(totalCents);
  }
}


  // 💡 Para el contador de envío gratuito USAMOS el total ya con descuentos,
  //    para que, si un artículo baja de 238.900 a 203.000, el mini-cart
  //    cuente 203.000 y no 238.900.
  if (!hasOnlyPO) {
    const subtotalForFreeShipping = 
      (typeof cart.total_price === 'number' && cart.total_price >= 0)
        ? cart.total_price                          // total con descuentos
        : (cart.items_subtotal_price || 0);         // fallback por si acaso

    updateShipping(subtotalForFreeShipping, cart);
  } else {
    if (shipTextEl) shipTextEl.textContent = '';
    if (shipBarEl)  shipBarEl.style.width='0%';
    if (etaTextEl)  etaTextEl.innerHTML = '';
  }


  // ✅ Cupón: pintar estado (chip / + / panel)
renderDiscountUIFromCart(cart);

bindQtyMini(cartItems, cart);
bindDeleteMini(cartItems);
syncPrestige(cart);
}


/* === BRIDGE: abrir el mini-cart de Celest desde otros bloques (p.ej. Related Products) ===
   PÉGALO DESPUÉS de renderMiniCart(cart). No altera lógica previa. */
if (!document.__celestMiniCartBridgeBound) {
  document.addEventListener('celest:openMiniCart', async (ev) => {
    try {
      // Si nos pasan el cart actualizado, úsalo; si no, lo pedimos.
      const incoming = ev?.detail?.cart;
      const cart = incoming || await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
      renderMiniCart(cart);
      openCart();
    } catch (_e) {
      // Si falla la petición por cualquier motivo, intenta abrir igualmente.
      openCart();
    }
  });
  document.__celestMiniCartBridgeBound = true;
}

// ✅ Si venimos de /discount/clear, reabrimos el mini-cart automáticamente
try{
  if (sessionStorage.getItem('celest_after_clear_discount_open_cart') === '1'){
    sessionStorage.removeItem('celest_after_clear_discount_open_cart');
    fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(r=>r.json())
      .then(cart => { renderMiniCart(cart); openCart(); })
      .catch(_=>{});
  }
}catch(_){}

    /* ===== ADD TO CART (AJAX) — sólo loader dentro del botón + flags de Pre-orden/Personalizado ===== */
if (form && addBtn) {
  form.addEventListener('submit', function (e) {
    // Personalización: antes de validar talla, aseguramos inputs ocultos
    if (window.__celestPz?.updateHiddenFields) window.__celestPz.updateHiddenFields();

    // Requiere talla si existe UI de tallas
    if (hasSizeUI && !getChosenSize()) {
      e.preventDefault();
      nudgeSizesRow();
      return;
    }

    updateSelectedVariantFromUI();
    if (!idInput?.value) {
      e.preventDefault();
      console.warn('No hay variante válida para añadir');
      return;
    }

    e.preventDefault();

    // ==== Loader SOLO dentro del botón ====
    if (SHOW_BTNS && LOADER_MODE !== 'off') {
      putLoaderInsideButton(addBtn, ICONS.add); // usamos el loader “bosquejo” dentro del botón
    }

    const fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');

    // ===== Flags para el carrito =====
        const IS_PREORDER = (root?.dataset?.preorder === 'true' || root?.dataset?.preorder === '1');

    // “Personalizado”…
    const IS_PERSONALIZABLE = (root?.dataset?.personalizable === 'true' || root?.dataset?.personalizable === '1');
    const HAS_CUSTOM_DATA  = !!(window.__celestPz?.hasData ? window.__celestPz.hasData() : false);

    // 🚀 NUEVO: ¿este producto es un regalo según el metacampo?
    const IS_GIFT = (root?.dataset?.regaloesun === 'true' || root?.dataset?.regaloesun === '1');

    if (IS_PREORDER) {
      fd.set('properties[_is_preorder]', '1');
    }
    if (IS_PERSONALIZABLE || HAS_CUSTOM_DATA) {
      // Marcamos el ítem para badge “Personalizado”
      fd.set('properties[_is_personalizado]', '1');
    }
    if (IS_GIFT) {
      // Marcamos el ítem para badge “Regalo”
      fd.set('properties[_is_gift]', '1');
    }
        // === Guardar precios base en properties para que el mini-cart
    //     pueda mostrar el descuento incluso desde otras páginas ===
    try {
      const vid = idInput?.value;
      let vPriceCents   = null;
      let vCompareCents = null;

      if (product && Array.isArray(product.variants) && vid) {
        const v = product.variants.find(v => String(v.id) === String(vid));
        if (v) {
          if (typeof v.price === 'number')            vPriceCents   = v.price;
          if (typeof v.compare_at_price === 'number') vCompareCents = v.compare_at_price;
        }
      }

      if (vPriceCents != null) {
        fd.set('properties[_cel_price_cents]', String(vPriceCents));
      }
      if (vCompareCents && vCompareCents > vPriceCents) {
        fd.set('properties[_cel_compare_cents]', String(vCompareCents));
      }
    } catch(_){}


    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(_added => fetch('/cart.js').then(r => r.json()))
      .then(async cart => {
  clearButtonLoader(addBtn);

  // ✅ Abre el mini-cart GLOBAL
  const opened = await celestOpenGlobalMiniCart(cart);

  // ⛑️ Si por alguna razón el global no existe, mantén tu fallback local
  if(!opened){
    renderMiniCart(cart);
    openCart();
  }
})

      .catch(err => {
        console.error('Add to cart error', err);
        clearButtonLoader(addBtn);
      });
  });
}




    /* ===== CHECKOUT loader visual ===================== */
    if(checkoutBtn && SHOW_BTNS && LOADER_MODE!=='off'){
      checkoutBtn.addEventListener('click', function(){
        putLoaderInsideButton(checkoutBtn, ICONS.checkout);
        setTimeout(()=>clearButtonLoader(checkoutBtn), 5000);
      });
    }
    


    /* ===== OVERLAY al tocar icono bolsa en header ===== */
    const overlay = document.querySelector('.celestLoaderOverlay');
    function overlaySetContent(node){
      if(!overlay) return;
      const inner = overlay.querySelector('.celestLoaderOverlay__inner');
      inner.innerHTML = '';
      inner.appendChild(node);
    }
    function showOverlay(){
      if(!overlay || !SHOW_OVERLAY || LOADER_MODE==='off') return;
      let node;
      const paths = resolveMorphPaths();
      switch(LOADER_MODE){
        case 'spin': node = buildSpin(ICONS.cart, OVER_SIZE); break;
        case 'morph': node = buildMorph(OVER_SIZE, paths); break;
        case 'both': node = buildBoth(OVER_SIZE, paths); break;
        case 'sketch': node = buildSketch(OVER_SIZE, SKETCH_IMG || ICONS.cart || ICONS.add); break;
        default: node = buildSpin(ICONS.cart, OVER_SIZE);
      }
      overlaySetContent(node);
      overlay.style.background = `rgba(0,0,0, ${Math.max(0, Math.min(100, OVER_ALPHA))/100})`;
      overlay.hidden = false;
    }
    function hideOverlay(){
      if(!overlay) return;
      overlay.hidden = true;
      const inner = overlay.querySelector('.celestLoaderOverlay__inner');
      if(inner) inner.innerHTML = '';
    }
    if(SHOW_OVERLAY && LOADER_MODE!=='off'){
      document.addEventListener('click', function(e){
        const cartIcon = e.target.closest('[data-cart-toggle], .header__icon--cart, a[href="/cart"], button[name="cart"], .js-open-cart, .Header__Icon--cart, .site-header__cart, .header__icon--bag');
        if(cartIcon){
          showOverlay();
          setTimeout(hideOverlay, 800);
        }
      });
      window.addEventListener('pageshow', hideOverlay);
      window.addEventListener('popstate', hideOverlay);
    }

    /* =================== Loader builders ====================== */
    function el(html){
      const t = document.createElement('template');
      t.innerHTML = html.trim();
      return t.content.firstElementChild;
    }
    function defaultMorphPaths(){
      return [
        'M40,10 C55,12 68,22 72,38 C76,53 71,68 58,76 C45,84 28,84 18,73 C8,62 6,43 14,28 C22,14 27,8 40,10 Z',
        'M38,8 C55,8 76,22 78,40 C80,58 63,77 44,79 C25,81 9,66 7,47 C5,28 21,8 38,8 Z',
        'M42,6 C60,10 78,26 78,44 C78,62 60,76 42,78 C24,80 8,70 6,52 C4,34 24,2 42,6 Z'
      ];
    }
    function resolveMorphPaths(){
      if(!MORPH_PATHS_RAW) return defaultMorphPaths();
      return MORPH_PATHS_RAW.split('\n').map(s=>s.trim()).filter(Boolean);
    }

    function buildSpin(imgUrl, size){
      if(imgUrl){
        return el(
          `<div class="celestLoader--btn" aria-hidden="true" style="inset:0;display:grid;place-items:center;pointer-events:none;">
             <img src="${imgUrl}" alt="" width="${size}" height="${size}" style="width:${size}px;height:${size}px;animation:celestSpin ${SPIN_MS}ms linear infinite;will-change:transform;"/>
           </div>`);
      }
      return el(
        `<div class="celestLoader--btn" aria-hidden="true" style="inset:0;display:grid;place-items:center;pointer-events:none;">
           <svg viewBox="0 0 40 40" width="${size}" height="${size}" style="animation:celestSpin ${SPIN_MS}ms linear infinite">
             <circle cx="20" cy="20" r="16" fill="none" stroke="currentColor" stroke-width="4" opacity="0.2"></circle>
             <path d="M20 4 a16 16 0 0 1 0 32" fill="none" stroke="currentColor" stroke-width="4"></path>
           </svg>
         </div>`);
    }
    function buildMorph(size, paths){
      const vals = paths.join(';');
      return el(
        `<div class="celestLoader--btn" aria-hidden="true" style="inset:0;display:grid;place-items:center;pointer-events:none;">
           <svg viewBox="0 0 84 84" width="${size}" height="${size}">
             <path fill="currentColor" opacity="0.95">
               <animate attributeName="d" dur="${MORPH_MS}ms" repeatCount="indefinite" values="${vals}" />
             </path>
           </svg>
         </div>`);
    }
    function buildBoth(size, paths){
      const node = buildMorph(size, paths);
      const svg  = node.querySelector('svg');
      if(svg) svg.style.animation = `celestSpin ${SPIN_MS}ms linear infinite`;
      return node;
    }
    function buildSketch(size, imgUrl){
      return el(
        `<div class="celestLoader--btn" aria-hidden="true" style="inset:0;display:grid;place-items:center;pointer-events:none;transform-origin:center;">
           <img src="${imgUrl}" alt="" width="${size}" height="${size}"
                style="width:${size}px;height:${size}px;animation:celestSketchIn 420ms ease-out both"/>
         </div>`);
    }
    function putLoaderInsideButton(btn, iconUrlForContext){
      if(!btn) return;
      btn.querySelectorAll('.celestLoader--btn').forEach(n => n.remove());
      let node;
      const paths = resolveMorphPaths();
      switch(LOADER_MODE){
        case 'off': return;
        case 'spin': node = buildSpin(iconUrlForContext, BTN_SIZE); break;
        case 'morph': node = buildMorph(BTN_SIZE, paths); break;
        case 'both': node = buildBoth(BTN_SIZE, paths); break;
        case 'sketch': node = buildSketch(SKETCH_SIZE, SKETCH_IMG || iconUrlForContext || ICONS.add || ICONS.checkout); break;
        default: node = buildSpin(iconUrlForContext, BTN_SIZE);
      }
      btn.classList.add('is-loading');
      btn.appendChild(node);
      const t = btn.querySelector('.js-addText');
      if(t) t.style.opacity = '0';
    }
    function clearButtonLoader(btn){
      if(!btn) return;
      btn.classList.remove('is-loading');
      btn.querySelectorAll('.celestLoader--btn').forEach(n => n.remove());
      const t = btn.querySelector('.js-addText');
      if(t) t.style.opacity = '';
    }

    /* =====================================================================
       CELEST PERSONALIZATION
       ===================================================================== */
    (function setupPersonalization(){
      const cfg = safeJSON(document.getElementById('CelestPersonalizationConfig'));
      if(!cfg?.enabled) return;

      const anchor = $('#celest-pz-anchor') || addBtn?.parentElement || root;
      if(!anchor) return;

      // Estado y API pública para el submit
      const state = {
        letters: ['', '', ''],
        colorHex: null,
        colorName: null,
        points: !!cfg.points_default,
        confirmed: false
      };
      function lettersRaw(){
        return state.letters.join('').trim();
      }
      function lettersDisplay(){
        const raw = state.letters.filter(Boolean).join('');
        if(!raw) return '';
        if(state.points && raw.length>1){
          return raw.split('').join('·'); // puntitos pegados, centrados
        }
        return raw;
      }

      // ---------- MOUNT: tarjeta/botón sobre el CTA ----------
      const mount = document.createElement('div');
      mount.className = 'celestPz__mount';
      anchor.parentNode.insertBefore(mount, anchor.nextSibling || addBtn);

      // Hidden inputs (para properties) — se inyectan en el form
      let fieldsWrap = form?.querySelector('.celestPz__fields');
      if(!fieldsWrap && form){
        fieldsWrap = document.createElement('div');
        fieldsWrap.className='celestPz__fields';
        fieldsWrap.hidden = true;
        fieldsWrap.innerHTML = `
          <input type="hidden" name="properties[Personalización]" value="">
          <input type="hidden" name="properties[Letras]" value="">
          <input type="hidden" name="properties[Color]" value="">
          <input type="hidden" name="properties[Puntos]" value="">
          <input type="hidden" name="properties[_pz_price_text]" value="">
          <input type="hidden" name="properties[_pz_config_json]" value="">
        `;
        form.appendChild(fieldsWrap);
      }

      // API pública para el submit (garantiza volcado en hidden fields)
      window.__celestPz = window.__celestPz || {};
      window.__celestPz.updateHiddenFields = function updateHiddenFields(){
        if(!fieldsWrap) return;
        const kv = Object.fromEntries([...fieldsWrap.querySelectorAll('input[name^="properties["]')].map(i=>[i.name,i]));
        const title = cfg.title || 'Personalización';
        const desc  = buildSummaryText();
        kv['properties[Personalización]'].value = title;
        kv['properties[Letras]'].value = lettersDisplay();
        kv['properties[Color]'].value  = state.colorName || '';
        kv['properties[Puntos]'].value = state.points ? 'Con' : 'Sin';
        kv['properties[_pz_price_text]'].value = cfg.price_cents>0 ? (cfg.price_text || fmtMoneyFromCents(cfg.price_cents)) : 'Gratuito';
        kv['properties[_pz_config_json]'].value = JSON.stringify({
          letters: state.letters, points: state.points,
          color: {name: state.colorName, hex: state.colorHex},
          pos:{x:cfg.pos_x,y:cfg.pos_y}, font_pct: cfg.font_pct
        });
      };

      // ---------- UI: Card (sin confirmar) ----------
      function renderCard(){
        const priceBadged = cfg.price_cents>0 ? (cfg.price_text || fmtMoneyFromCents(cfg.price_cents)) : 'Gratuito';
        mount.innerHTML = `
          <button type="button" class="celestPz__card" aria-haspopup="dialog">
            ${cfg.button_image ? `<div class="celestPz__thumb"><img src="${cfg.button_image}" alt=""></div>` : ``}
            <div class="celestPz__content">
              <div class="celestPz__title">${cfg.title||'Personalización'}</div>
              <div class="celestPz__price">${priceBadged}</div>
              ${cfg.description ? `<div class="celestPz__desc">${cfg.description}</div>` : ``}
            </div>
          </button>
        `;
        mount.querySelector('.celestPz__card')?.addEventListener('click', openModal);
      }

      // ---------- UI: Resumen (tras confirmar) ----------
      function buildSummaryText(){
        const parts = [];
        if(lettersDisplay()) parts.push(`Letras: <b>${lettersDisplay()}</b>`);
        if(state.colorName) parts.push(`Color: ${state.colorName}`);
        parts.push(`Posición: Horizontal`);
        parts.push(`Puntos: ${state.points?'Con':'Sin'}`);
        return parts.join('<br>');
      }
      function renderSummary(){
        const priceBadged = cfg.price_cents>0 ? (cfg.price_text || fmtMoneyFromCents(cfg.price_cents)) : 'Gratuito';
        mount.innerHTML = `
          <div class="celestPz__card celestPz__card--summary" role="group" aria-label="${cfg.title||'Personalización'}">
            <div class="celestPz__summaryHead">
              <div class="celestPz__title">${cfg.title||'Personalización'}</div>
              <button type="button" class="celestPz__edit">Modificar</button>
            </div>
            <div class="celestPz__summaryBody">
              <div class="celestPz__summaryText">
                ${buildSummaryText()}
              </div>
              <div class="celestPz__summaryPrice">${cfg.price_cents>0 ? priceBadged : 'Cortesía'}</div>
              <button type="button" class="celestPz__remove">Eliminar</button>
            </div>
          </div>
        `;
        mount.querySelector('.celestPz__edit')?.addEventListener('click', openModal);
        mount.querySelector('.celestPz__remove')?.addEventListener('click', ()=>{
          state.letters=['','','']; state.colorHex=null; state.colorName=null; state.points=!!cfg.points_default; state.confirmed=false;
          renderCard();
          // limpiar hidden fields
          if(fieldsWrap) fieldsWrap.querySelectorAll('input').forEach(i=>i.value='');
        });
        // garantizar fields para el add-to-cart
        window.__celestPz.updateHiddenFields();
      }

      // ---------- MODAL ----------
      let modal, body, previewImg, previewText, inputs, colorsWrap, confirmBtn, resetBtn, closeBtn, pointsRadios;
      function ensureModal(){
        if(modal) return;
        modal = el(`
          <div class="celestPz__modal" hidden>
            <div class="celestPz__dialog" role="dialog" aria-modal="true" aria-label="${cfg.title||'Personalización'}">
              <button class="celestPz__close" aria-label="Cerrar"><span class="celestPdp__x" aria-hidden="true"></span></button>
              <div class="celestPz__header"><h3>${cfg.title||'Personalización'}</h3></div>
              <div class="celestPz__preview">
                ${cfg.preview_image ? `<img class="celestPz__previewImg" src="${cfg.preview_image}" alt="">` : `<div class="celestPz__ph"></div>`}
                <div class="celestPz__letters"></div>
              </div>
              <div class="celestPz__form">
                <div class="celestPz__row">
                  <label class="celestPz__label">Letras</label>
                  <div class="celestPz__inputs">
                    <input maxlength="1" class="celestPz__in" inputmode="latin" autocomplete="off">
                    <input maxlength="1" class="celestPz__in" inputmode="latin" autocomplete="off">
                    <input maxlength="1" class="celestPz__in" inputmode="latin" autocomplete="off">
                  </div>
                </div>
                <div class="celestPz__row">
                  <label class="celestPz__label">Colores</label>
                  <div class="celestPz__colors"></div>
                </div>
                <div class="celestPz__row">
                  <label class="celestPz__label">Puntos</label>
                  <div class="celestPz__radios">
                    <label><input type="radio" name="pzPoints" value="1"> Con</label>
                    <label><input type="radio" name="pzPoints" value="0"> Sin</label>
                  </div>
                </div>
                <div class="celestPz__actions">
                  <button class="celestPz__confirm" disabled>Confirmar</button>
                  <button class="celestPz__reset" type="button">Resetear</button>
                </div>
                ${cfg.legal_text && cfg.legal_url ? `<div class="celestPz__legal"><a href="${cfg.legal_url}" target="_blank" rel="noopener">${cfg.legal_text}</a></div>`:``}
              </div>
            </div>
          </div>
        `);
        root.appendChild(modal);
        body        = $('.celestPz__dialog', modal);
        previewImg  = $('.celestPz__previewImg', modal);
        previewText = $('.celestPz__letters', modal);
        inputs      = $$('.celestPz__in', modal);
        colorsWrap  = $('.celestPz__colors', modal);
        confirmBtn  = $('.celestPz__confirm', modal);
        resetBtn    = $('.celestPz__reset', modal);
        closeBtn    = $('.celestPz__close', modal);
        pointsRadios= $$('input[name="pzPoints"]', modal);

        // posición/tamaño del texto sobre la foto
        previewText.style.setProperty('--pz-font', (cfg.font_pct||22)+'%');
        previewText.style.left = (cfg.pos_x||50)+'%';
        previewText.style.top  = (cfg.pos_y||50)+'%';

        // inputs: uppercase + mover foco
        inputs.forEach((inp,i)=>{
          inp.addEventListener('input', ()=>{
            inp.value = (inp.value||'').toUpperCase().replace(/[^A-ZÑ]/g,'').slice(0,1);
            state.letters[i] = inp.value;
            refreshPreview();
            if(inp.value && inputs[i+1]) inputs[i+1].focus();
            validate();
          });
          inp.addEventListener('keydown', (e)=>{
            if(e.key==='Backspace' && !inp.value && inputs[i-1]) inputs[i-1].focus();
          });
        });

        // radios puntos
        pointsRadios.forEach(r=>{
          r.addEventListener('change', ()=>{
            state.points = r.value==='1';
            refreshPreview(); validate();
          });
        });
        (cfg.points_default ? pointsRadios[0] : pointsRadios[1]).checked = true;

        // paleta de colores desde JSON
        function parseColors(cs){
          if(Array.isArray(cs)) return cs;
          if(typeof cs==='string'){ try{ const v=JSON.parse(cs); return Array.isArray(v)?v:[]; }catch(_){ return []; } }
          if(typeof cs==='object' && cs) return Object.values(cs);
          return [];
        }
        const colors = parseColors(cfg.colors||[]);
        colorsWrap.innerHTML = colors.map((c,i)=>`
          <button type="button" class="celestPz__sw ${i===0?'is-active':''}" data-name="${c.name}" data-hex="${c.hex}" aria-label="${c.name}">
            <span style="background:${c.hex}"></span>
          </button>
        `).join('');
        const sws = $$('.celestPz__sw', colorsWrap);
        function chooseColor(sw){
          sws.forEach(x=>x.classList.remove('is-active'));
          sw.classList.add('is-active');
          state.colorName = sw.dataset.name;
          state.colorHex  = sw.dataset.hex;
          refreshPreview(); validate();
        }
        if(sws[0]) chooseColor(sws[0]);
        colorsWrap.addEventListener('click', e=>{
          const sw=e.target.closest('.celestPz__sw'); if(!sw) return;
          chooseColor(sw);
        });

        // acciones
        resetBtn.addEventListener('click', ()=>{
          inputs.forEach(i=>i.value=''); state.letters=['','',''];
          state.points = !!cfg.points_default;
          (cfg.points_default ? pointsRadios[0] : pointsRadios[1]).checked = true;
          if(sws[0]) chooseColor(sws[0]); else { state.colorHex=null; state.colorName=null; }
          refreshPreview(); validate();
        });
        closeBtn.addEventListener('click', closeModal);
        modal.addEventListener('click', e=>{ if(e.target===modal) closeModal(); });

        confirmBtn.addEventListener('click', ()=>{
          state.confirmed = true;
          window.__celestPz.updateHiddenFields();
          closeModal();
          renderSummary();
          // desplazar al área del botón
          mount.scrollIntoView({block:'center', behavior:'smooth'});
        });

        refreshPreview(); validate();
      }

      function refreshPreview(){
        const txt = lettersDisplay();
        previewText.textContent = txt;
        previewText.style.color = state.colorHex || '#111';
        const cls = 'celestPz-hasLetters';
document.documentElement.classList.toggle(cls, !!txt);

      }
      function validate(){
        const okLetters = lettersRaw().length >= 1; // 1–3 letras
        const okColor   = !!state.colorHex;
        confirmBtn?.toggleAttribute('disabled', !(okLetters && okColor));
      }

      function openModal(){
        ensureModal();
        modal.hidden=false;
        requestAnimationFrame(()=>body.classList.add('is-open'));
        document.body.style.overflow='hidden';
        // si ya había datos, volcarlos
        inputs.forEach((i,idx)=>{ i.value = state.letters[idx]||''; });
        $$('input[name="pzPoints"]', modal).forEach(r=> r.checked = (r.value==='1')===state.points );
        refreshPreview(); validate();
      }
      function closeModal(){
        if(!modal || modal.hidden) return;
        body.classList.remove('is-open');
        body.addEventListener('transitionend', ()=>{ modal.hidden=true; }, {once:true});
        document.body.style.overflow='';
      }

      // Render inicial
      state.confirmed ? renderSummary() : renderCard();
    })();
    /* ===== Personalización: abrir/cerrar + guardar en properties ===== */
   function initPersonalization(root){
  const pers = root.querySelector('.celestPers');
  if(!pers) return;

  const modal   = pers.querySelector('.celestPers__modal');
  const sheet   = pers.querySelector('.celestPers__sheet');
  const openers = pers.querySelectorAll('[data-pers-open]');
  const closers = pers.querySelectorAll('[data-pers-close]');
  const confirm = pers.querySelector('.js-pers-confirm');
  const reset   = pers.querySelector('.js-pers-reset');
  const summary = pers.querySelector('.celestPers__summary');
  const card    = pers.querySelector('.celestPers__card');

  const formEl  = root.querySelector('[data-product-form]') || root.querySelector('form[action*="/cart/add"]');

  function open(){
    if(!modal) return;
    modal.hidden = false;
    requestAnimationFrame(()=> sheet?.classList.add('is-open'));
    if(isMobile.matches) document.body.style.overflow = 'hidden';
  }
  function close(){
    sheet?.classList.remove('is-open');
    sheet?.addEventListener('transitionend', ()=>{ modal.hidden = true; }, {once:true});
    document.body.style.overflow = '';
  }

  openers.forEach(b => b.addEventListener('click', e => { e.preventDefault(); open(); }));
  modal?.addEventListener('click', e => { if(e.target === modal) close(); });
  closers.forEach(b => b.addEventListener('click', e => { e.preventDefault(); close(); }));

  // Live preview
  const inputs = Array.from(pers.querySelectorAll('.celestPers__letter'));
  const mono   = pers.querySelector('.celestPers__monogram');
  function getPoints(){
    return pers.querySelector('input[name="pers_points"]:checked')?.value === 'with';
  }
  function getColor(){
    return pers.querySelector('.celestPers__color input[type="radio"]:checked')?.value || '';
  }
  function valueLetters(){
    const raw = inputs.map(i => (i.value||'').toUpperCase().replace(/[^A-ZÑÁÉÍÓÚÜ]/g,''));
    const letters = raw.filter(Boolean);
    if(!letters.length) return '';
    return getPoints() ? letters.join('·') : letters.join('');
  }
  function paint(){
    if(!mono) return;
    mono.textContent = valueLetters() || 'ABC';
    const sel = pers.querySelector('.celestPers__color input[type="radio"]:checked');
    if(sel){
      const chip = sel.closest('.celestPers__color')?.querySelector('span');
      mono.style.color = chip ? getComputedStyle(chip).backgroundColor : '';
    }
  }
  inputs.forEach(i => i.addEventListener('input', paint));
  pers.querySelectorAll('.celestPers__color input').forEach(r => r.addEventListener('change', paint));
  pers.querySelectorAll('input[name="pers_points"]').forEach(r => r.addEventListener('change', paint));

  // Guardar en form como line item properties
  function applyToForm(){
    if(!formEl) return;
    // borra anteriores
    formEl.querySelectorAll('[data-pers-prop]').forEach(n => n.remove());

    const letters = inputs.map(i => (i.value||'').toUpperCase().replace(/[^A-ZÑÁÉÍÓÚÜ]/g,'')).filter(Boolean).join('');
    const color   = getColor();
    const points  = getPoints() ? 'Con' : 'Sin';
    const title   = pers.dataset.title || 'Personalización';

    const props = [
      ['Personalización', title],
      ['Letras', letters],
      ['Color', color],
      ['Puntos', points]
    ];
    props.forEach(([k,v])=>{
      const h = document.createElement('input');
      h.type='hidden';
      h.name=`properties[${k}]`;
      h.value=v || '';
      h.setAttribute('data-pers-prop','');
      formEl.appendChild(h);
    });
  }

  function renderSummary(){
    if(!summary) return;
    const letters = valueLetters().replace(/·/g,''); // mostrar sin puntos en resumen de “Letras”
    const color   = getColor() || '—';
    const points  = getPoints() ? 'Con' : 'Sin';
    summary.innerHTML = `
      <div class="celestPers__sumTitle">${pers.dataset.title || 'Personalización'}</div>
      <div class="celestPers__sumRow"><b>Letras:</b> ${letters || '—'}</div>
      <div class="celestPers__sumRow"><b>Color:</b> ${color}</div>
      <div class="celestPers__sumRow"><b>Puntos:</b> ${points}</div>
      <button type="button" class="celestPers__edit" data-pers-open>Modificar</button>
      <button type="button" class="celestPers__remove">Eliminar</button>
    `;
    summary.hidden = false;
    // Nuevos listeners del contenido inyectado:
    summary.querySelector('.celestPers__edit')?.addEventListener('click', e => { e.preventDefault(); open(); });
    summary.querySelector('.celestPers__remove')?.addEventListener('click', e => {
      e.preventDefault();
      formEl?.querySelectorAll('[data-pers-prop]').forEach(n=>n.remove());
      inputs.forEach(i=> i.value='');
      pers.querySelectorAll('.celestPers__color input').forEach(r => r.checked=false);
      pers.querySelector('input[name="pers_points"][value="without"]')?.click();
      summary.hidden = true;
      paint();

      /* ===== Header transparente sobre la galería (solo móvil en PDP) ===== */
(function headerHero(){
  if (!isMobile.matches) return;               // solo móvil
  const header = document.getElementById('celest-header');
  if (!header) return;

  // Sentinela para detectar cuándo salimos de la zona superior (“hero”)
  let s = root.querySelector('.celestPdp__sentinel');
  if (!s) {
    s = document.createElement('div');
    s.className = 'celestPdp__sentinel';
    root.prepend(s);
  }

  header.classList.add('celest-header--transparent');

  const io = new IntersectionObserver(([en])=>{
    if (en && en.isIntersecting) {
      header.classList.add('celest-header--transparent');
      header.classList.remove('celest-header--solid');
    } else {
      header.classList.remove('celest-header--transparent');
      header.classList.add('celest-header--solid');
    }
  }, { rootMargin: '-1px 0px 0px 0px', threshold: 0 });

  io.observe(s);
})();

    });
  }

  confirm?.addEventListener('click', e=>{
    e.preventDefault();
    applyToForm();
    renderSummary();
    close();
  });

  reset?.addEventListener('click', e=>{
    e.preventDefault();
    inputs.forEach(i=> i.value='');
    pers.querySelectorAll('.celestPers__color input').forEach(r => r.checked=false);
    pers.querySelector('input[name="pers_points"][value="without"]')?.click();
    formEl?.querySelectorAll('[data-pers-prop]').forEach(n=>n.remove());
    summary.hidden = true;
    paint();
  });

  // pinta estado inicial
  paint();
}
(function(){
  const onReady = fn => (document.readyState==='loading'
    ? document.addEventListener('DOMContentLoaded', fn, { once:true })
    : fn());

  onReady(function(){
    // Solo en PDP (la clase la pusimos en <body>)
    if (!document.body.classList.contains('celest-pdp-hero')) return;

    const header = document.getElementById('celest-header');
    if (!header) return;

    const isMobile = matchMedia('(max-width: 989px)');

    function applyScrollState(){
      if (!isMobile.matches) {
        header.classList.remove('is-scrolled');
        return;
      }
      if (window.scrollY > 4) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }

    applyScrollState();
    window.addEventListener('scroll', applyScrollState, { passive:true });
    window.addEventListener('resize', applyScrollState);
  });
})();

    /* ===== Inicialización general ===== */
    preselectFirstColor();
    updateSelectedVariantFromUI();
    refreshCTA();
    initPersonalization(root);
  }

})();

/* === CELEST • Stock-aware sizes & CTA (INLINE SIZES) — v4 ================= */
(function(){
  const root = document.getElementById('celest-mobile-pdp');
  if(!root) return;
    if (root.__celestSizesV4) return;
  root.__celestSizesV4 = true;


  const IS_PREORDER = (root.dataset.preorder === 'true' || root.dataset.preorder === '1');
  const LABEL_ADD   = IS_PREORDER ? 'Pre-ordenar' : 'Agregar a la bolsa';
  const LABEL_OOS   = 'Agotado';

  const form    = root.querySelector('[data-product-form]') || root.querySelector('form[action*="/cart/add"]');
  const idInput = form && form.querySelector('input[name="id"]');

  const addBtn  = root.querySelector('.celestPdp__addBtn, button[name="add"], [data-add-to-cart], .product-form__submit');
  const addText = addBtn && (addBtn.querySelector('.js-addText') || addBtn);

  const swWrap   = root.querySelector('.celestPdp__swatches');
  const sizeWrap = root.querySelector('.celestPdp__sizes');

  const sizeNote = root.querySelector('.celestPdp__sizeNote'); // opcional

  const pdpJsonEl= document.getElementById('ProductJson-celest-mobile-pdp');
  const product  = pdpJsonEl ? JSON.parse(pdpJsonEl.textContent || '{}') : null;
  if(!product?.variants?.length || !idInput || !addBtn) return;

  // ----- indices (color/talla) -----
  const guessIndex = (name) => {
    const i = (product.options || []).findIndex(o => new RegExp(name,'i').test(o));
    return i >= 0 ? i : 0;
  };
  const colorIndex = swWrap?.dataset?.optionIndex != null ? Number(swWrap.dataset.optionIndex) : guessIndex('color|colour|colorway');
  const sizeIndex  = sizeWrap?.dataset?.optionIndex != null ? Number(sizeWrap.dataset.optionIndex) : guessIndex('talla|size|valor|amount|denomination');

  // ----- map variantes -----
  const vmap = new Map();
  product.variants.forEach(v=>{
    vmap.set([v.option1,v.option2,v.option3].map(x=>x||'').join('||'), v);
  });

  const currentSelection = {0:null,1:null,2:null};
  let userPickedSize = false;

  function setCTAState(state){
    if(!addBtn) return;
    if(state === 'soldout'){
      addBtn.disabled = true;
      addBtn.classList.add('is-soldout');
      addBtn.classList.remove('is-ready');
      if(addText) addText.textContent = LABEL_OOS;
      addBtn.setAttribute('aria-disabled','true');
    }else{
      addBtn.disabled = false;
      addBtn.classList.remove('is-soldout');
      addBtn.classList.add('is-ready');
      if(addText) addText.textContent = LABEL_ADD;
      addBtn.removeAttribute('aria-disabled');
    }
  }

  function variantFromSelection(sel){
    const o1 = sel[0] || ''; const o2 = sel[1] || ''; const o3 = sel[2] || '';
    return vmap.get([o1,o2,o3].join('||')) || null;
  }

  function getActiveSwatchValue(){
    if(!swWrap) return null;
    const el = swWrap.querySelector('.celestPdp__swatch.is-active, .celestPdp__swatch[aria-pressed="true"], .celestPdp__swatch[aria-current="true"]');
    return el ? (el.dataset.value || el.getAttribute('data-value') || (el.textContent||'').trim()) : null;
  }

  function getActiveSizeBtn(){
    if(!sizeWrap) return null;
    return sizeWrap.querySelector('.celestPdp__size.is-active') || null;
  }

  function paintSizes(){
    if(!sizeWrap) return;
    const buttons = Array.from(sizeWrap.querySelectorAll('.celestPdp__size'));

    buttons.forEach(btn=>{
      const val = btn.dataset.value || btn.textContent.trim();
      const trial = {...currentSelection, [sizeIndex]: val};
      const v = variantFromSelection(trial);
      const ok = !!(v && v.available);

      // ✅ Para tu “línea diagonal” usa .is-disabled (CSS)
      btn.classList.toggle('is-disabled', !ok);
      btn.classList.toggle('is-oos', !ok);

      // Importante: NO usar btn.disabled para permitir click y mostrar nota
      btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    });
  }

  function ensureDefaultSizeSelected(){
    if(!sizeWrap) return;
    if(getActiveSizeBtn()) return;

    const firstOk = Array.from(sizeWrap.querySelectorAll('.celestPdp__size'))
      .find(b => !b.classList.contains('is-disabled'));

    if(firstOk){
      firstOk.classList.add('is-active');
      currentSelection[sizeIndex] = firstOk.dataset.value || firstOk.textContent.trim();
    }
  }

  function syncIdAndCta(){
    const v = variantFromSelection(currentSelection);
    if(v){
      idInput.value = v.id;
      setCTAState(v.available ? 'ready' : 'soldout');
    }else{
      // fallback: si no hay match exacto, intenta 1ª disponible del color
      const col = currentSelection[colorIndex];
      if(col){
        const firstAvailForColor = product.variants.find(x => x[`option${colorIndex+1}`] === col && x.available);
        if(firstAvailForColor){
          currentSelection[0] = firstAvailForColor.option1 || '';
          currentSelection[1] = firstAvailForColor.option2 || '';
          currentSelection[2] = firstAvailForColor.option3 || '';
          idInput.value = firstAvailForColor.id;
          setCTAState('ready');
        }else{
          setCTAState('soldout');
        }
      }else{
        setCTAState('ready');
      }
    }
  }

  // ----- init -----
  (function init(){
    // 1) base desde idInput o 1ª disponible
    const def =
      product.variants.find(v => String(v.id) === String(idInput.value)) ||
      product.variants.find(v => v.available) ||
      product.variants[0];

    currentSelection[0] = def?.option1 || '';
    currentSelection[1] = def?.option2 || '';
    currentSelection[2] = def?.option3 || '';

    // 2) sincroniza color UI si existe
    const uiColor = getActiveSwatchValue();
    if(uiColor) currentSelection[colorIndex] = uiColor;

    // 3) pinta y selecciona primera talla SIEMPRE por defecto
    paintSizes();
    ensureDefaultSizeSelected();
    syncIdAndCta();
    paintSizes();
  })();

  // ----- swatch click -----
  swWrap?.addEventListener('click', (e)=>{
    const btn = e.target.closest('.celestPdp__swatch');
    if(!btn) return;

    // Visual active
    swWrap.querySelectorAll('.celestPdp__swatch').forEach(b=>b.classList.toggle('is-active', b===btn));

    const colorVal = btn.dataset.value || btn.title || (btn.textContent||'').trim() || '';
    currentSelection[colorIndex] = colorVal;

    // ✅ actualiza label de color si existe
    const colorValueEl = root.querySelector('.js-colorValue');
    if(colorValueEl) colorValueEl.textContent = colorVal;

    // repintar tallas según color
    paintSizes();

    // Si el usuario NO escogió talla manual, forzamos primera disponible del color
    if(!userPickedSize){
      // limpia activa previa visual
      sizeWrap?.querySelectorAll('.celestPdp__size').forEach(b=>b.classList.remove('is-active'));
      currentSelection[sizeIndex] = null;
      ensureDefaultSizeSelected();
    }

    // Si ya había talla elegida, se mantiene (aunque quede OOS -> CTA Agotado y queda marcada)
    syncIdAndCta();
    paintSizes();
  });

  // ----- size click -----
  sizeWrap?.addEventListener('click', (e)=>{
    const btn = e.target.closest('.celestPdp__size');
    if(!btn) return;

    // Si está agotada: muestra nota (si existe) y deja CTA en soldout si esa combinación queda así
    if(btn.classList.contains('is-disabled')){
      if(sizeNote){
        sizeNote.hidden = false;
        clearTimeout(sizeNote.__t);
        sizeNote.__t = setTimeout(()=>{ sizeNote.hidden = true; }, 1400);
      }
      // mantener selección/cta según lo que esté seleccionado actualmente
      return;
    }

    userPickedSize = true;

    sizeWrap.querySelectorAll('.celestPdp__size').forEach(b=>b.classList.remove('is-active'));
    btn.classList.add('is-active');

    currentSelection[sizeIndex] = btn.dataset.value || btn.textContent.trim();
    if(sizeNote) sizeNote.hidden = true;

    syncIdAndCta();
    paintSizes();
  });

})();

 

/* ===== CELEST • Gallery by color (FILTRA y hace scroll a la 1ª foto del color) ===== */
(function () {
  const root = document.getElementById('celest-mobile-pdp');
  if (!root) return;

  function slidesWrap(){
    return root.querySelector('.celestPdp__slides, .product__media-list');
  }
  function allSlides(){
    const wrap = slidesWrap();
    if (!wrap) return [];
    return Array.from(wrap.querySelectorAll('.celestPdp__slide, .product__media-item'));
  }

  function matchesColor(slide, colorDown){
    const dc = (slide.getAttribute('data-color') || '').trim().toLowerCase();
    const img = slide.querySelector('img');
    const alt = (img?.alt || '').toLowerCase();
    const src = (img?.currentSrc || img?.src || '').toLowerCase();
    if (!colorDown) return true;
    return (dc === colorDown) || alt.includes(colorDown) || src.includes(colorDown);
  }

  function filterSlidesByColor(colorDown){
    const slides = allSlides();
    if (!slides.length) return {shown:0,target:null};

    let shown = 0;
    let firstMatch = null;

    slides.forEach(s=>{
      const ok = matchesColor(s, colorDown);
      s.classList.toggle('is-hidden', !ok);
      if (ok){
        shown++;
        if (!firstMatch) firstMatch = s;
      }
    });

    // Si no hubo ninguna coincidencia, mostramos todo como fallback
    if (shown === 0){
      slides.forEach(s=>s.classList.remove('is-hidden'));
      shown = slides.length;
      firstMatch = slides[0];
    }

    // Notificar a la barra/contador que cambió el set visible
    root.dispatchEvent(new CustomEvent('celest:gallery:filtered', { detail:{ count: shown } }));

    return {shown, target:firstMatch};
  }

  function scrollToEl(el){
    if (!el) return;
    // Para carrusel (móvil) usamos scrollIntoView centrado; en desktop (lista) también vale
    try{ el.scrollIntoView({ behavior:'smooth', inline:'center', block:'nearest' }); }
    catch(_){ el.scrollIntoView({ behavior:'smooth' }); }
  }

  function applyColor(colorDown){
    const { target } = filterSlidesByColor(colorDown);
    scrollToEl(target);
  }

  function getSwatchColorDown(sw){
    return (sw.getAttribute('data-value-down') || sw.getAttribute('data-value') || '')
      .trim()
      .toLowerCase();
  }

  // 1) Click en swatch → filtrar + posicionar
  document.addEventListener('click', function (ev) {
    const sw = ev.target.closest('#celest-mobile-pdp .celestPdp__swatch');
    if (!sw) return;
    const colorDown = getSwatchColorDown(sw);
    // Esperamos un tick por si otros listeners cambian estado antes
    setTimeout(()=> applyColor(colorDown), 0);
  });

  // 2) Al cargar: si hay un color activo/preseleccionado, aplicamos de una
  document.addEventListener('DOMContentLoaded', function () {
    let activeSw = root.querySelector('.celestPdp__swatches .celestPdp__swatch.is-active')
                  || root.querySelector('.celestPdp__swatches .celestPdp__swatch');
    if (activeSw) applyColor(getSwatchColorDown(activeSw));
  });
})();
/* =========================================================
   CELEST • Zoom Fullscreen tipo Undergold
   - Usa #celest-mobile-pdp .celestPdp__slide
   - Solo imágenes visibles (variante actual)
   - Pan mejorado + swipe navegación en mobile
   - Pinch-zoom solo en la foto (sin deformar la página)
   - EXTRA: si el slide es VIDEO, se abre el video en
     fullscreen nativo en vez de convertirlo en foto.
   ========================================================= */
(function() {
  var root  = document.getElementById('celest-mobile-pdp');
  var modal = document.getElementById('celest-zoom-modal');
  if (!root || !modal) return;

  var imgEl    = modal.querySelector('.celestZoom__img');
  var prevBtn  = modal.querySelector('.celestZoom__prev');
  var nextBtn  = modal.querySelector('.celestZoom__next');
  var closeBtn = modal.querySelector('.celestZoom__close');

  var slidesData   = [];
  var currentIndex = 0;

  var isOpen   = false;
  var isZoomed = false;

  var baseScale = 1;
  var scale     = 1;
  var minScale  = 1;
  var maxScale  = 3;

  // ===== CONFIGURABLES =====
  // Movimiento al arrastrar con zoom (>1 = más movimiento)
  var PAN_SENSITIVITY = 5.0;
  // Distancia mínima para swipe de cambio de foto (sin zoom)
  var SWIPE_MIN_DISTANCE = 60;
  // Tolerancia vertical máxima para que cuente como swipe horizontal
  var SWIPE_MAX_OFF_AXIS = 40;
  // Umbral click vs drag
  var DRAG_THRESHOLD = 6; // px
  // Sensibilidad pinch:
  // 1   = directo
  // < 1 = más suave (requiere más gesto)
  // > 1 = más agresivo
  var PINCH_SENSITIVITY = 0.7;
  // =========================

  var isPanning = false;
  var startX = 0, startY = 0;
  var lastX  = 0, lastY  = 0;
  var panOriginX = 0, panOriginY = 0;

  var pointers         = {};
  var initialPinchDist = 0;
  var pinchStartScale  = 1;

  // Click / drag / swipe
  var pointerDownX = 0;
  var pointerDownY = 0;
  var movedOnLastInteraction = false;
  var swipeTracking = false;
  var swipeStartX = 0;
  var swipeStartY = 0;

  /* ---------- Helpers ---------- */

  function getVisibleSlides() {
    var slides = root.querySelectorAll('.celestPdp__slide');
    var result = [];
    slides.forEach(function(slide) {
      if (slide.classList.contains('is-hidden')) return;

      // Si el slide es VIDEO, lo saltamos en el modal de zoom.
      // Ese tipo de media se maneja aparte (fullscreen nativo).
      var videoInSlide = slide.querySelector('video');
      if (videoInSlide) return;

      var img = slide.querySelector('img');
      if (!img) return;
      var src = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
      if (!src) return;
      result.push({
        el: slide,
        src: src,
        alt: img.alt || ''
      });
    });
    return result;
  }

  function refreshSlidesData() {
    slidesData = getVisibleSlides();
  }

  function clamp(val, min, max) {
    return Math.max(min, Math.min(max, val));
  }

  // Limita el pan para que la imagen no se vaya demasiado lejos
  function clampPan() {
    if (scale <= 1.02) {
      lastX = 0;
      lastY = 0;
      return;
    }

    var rect = modal.getBoundingClientRect();
    var vw = rect.width;
    var vh = rect.height;

    // Aproximación: usamos el viewport como referencia
    var imgWidth  = vw * scale;
    var imgHeight = vh * scale;

    var maxX = Math.max(0, (imgWidth  - vw) / 2);
    var maxY = Math.max(0, (imgHeight - vh) / 2);

    lastX = clamp(lastX, -maxX, maxX);
    lastY = clamp(lastY, -maxY, maxY);
  }

  function applyTransform() {
    clampPan();
    imgEl.style.transform =
      'translate3d(' + lastX + 'px,' + lastY + 'px,0) scale(' + scale + ')';
  }

  function setImage(index) {
    if (!slidesData.length) return;
    currentIndex = (index + slidesData.length) % slidesData.length;
    var item = slidesData[currentIndex];
    if (!item) return;

    resetTransform(true);

    imgEl.src = item.src;
    imgEl.alt = item.alt;
  }

  function openModal(startIndex) {
    refreshSlidesData();
    if (!slidesData.length) return;

    setImage(startIndex || 0);

    isOpen = true;
    modal.classList.remove('is-closing');
    modal.classList.add('is-open');
    document.body.classList.add('celestZoom-open');

    if (closeBtn) closeBtn.focus();
    bindKeys();
  }

  function closeModal() {
    if (!isOpen) return;
    isOpen = false;

    modal.classList.add('is-closing');

    setTimeout(function() {
      modal.classList.remove('is-open', 'is-closing', 'is-zoomed');
      document.body.classList.remove('celestZoom-open');
      imgEl.src = '';
      resetTransform(true);
      unbindKeys();
    }, 210);
  }

  function prevImage() {
    if (!slidesData.length) return;
    setImage(currentIndex - 1);
  }

  function nextImage() {
    if (!slidesData.length) return;
    setImage(currentIndex + 1);
  }

  function resetTransform() {
    scale = baseScale = 1;
    lastX = lastY = 0;
    isZoomed = false;
    isPanning = false;
    movedOnLastInteraction = false;
    swipeTracking = false;
    initialPinchDist = 0;
    pinchStartScale = 1;

    modal.classList.remove('is-zoomed');

    imgEl.style.cursor = 'zoom-in';
    imgEl.style.transform = 'translate3d(0,0,0) scale(1)';
  }

  // Entrar en zoom (el salir se maneja en el click)
  function toggleZoomIn() {
    scale = baseScale = 2;
    isZoomed = true;
    modal.classList.add('is-zoomed');

    lastX = 0;
    lastY = 0;
    imgEl.style.cursor = 'grab';
    applyTransform();
  }

  /* ---------- Eventos teclado ---------- */

  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      nextImage();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      prevImage();
    }
  }

  function bindKeys() {
    document.addEventListener('keydown', onKey);
  }
  function unbindKeys() {
    document.removeEventListener('keydown', onKey);
  }

  /* ---------- Bloquear zoom nativo página (multi-touch) ---------- */

  function preventNativeZoom(e) {
    if (!isOpen) return;
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
    }
  }

  // Importante: passive:false para poder hacer preventDefault en mobile
  document.addEventListener('touchmove', preventNativeZoom, { passive: false });

  /* ---------- Pan + Swipe (Pointer Events) ---------- */

  imgEl.addEventListener('pointerdown', function(e) {
    if (!isOpen) return;

    pointerDownX = e.clientX;
    pointerDownY = e.clientY;
    movedOnLastInteraction = false;

    if (scale > 1.02) {
      // Iniciar PAN con zoom
      isPanning = true;
      panOriginX = lastX;
      panOriginY = lastY;

      try { imgEl.setPointerCapture(e.pointerId); } catch(err) {}
      imgEl.style.cursor = 'grabbing';
    } else {
      // Sin zoom: preparamos posible swipe
      swipeTracking = true;
      swipeStartX = e.clientX;
      swipeStartY = e.clientY;
    }
  });

  imgEl.addEventListener('pointermove', function(e) {
    if (!isOpen) return;

    // PAN con zoom activo
    if (isPanning && scale > 1.02) {
      var dx = (e.clientX - pointerDownX) * PAN_SENSITIVITY;
      var dy = (e.clientY - pointerDownY) * PAN_SENSITIVITY;

      lastX = panOriginX + dx;
      lastY = panOriginY + dy;

      if (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD) {
        movedOnLastInteraction = true;
      }

      applyTransform();
      return;
    }

    // SWIPE detección cuando no hay zoom
    if (swipeTracking && scale <= 1.02) {
      var sdx = e.clientX - swipeStartX;
      var sdy = e.clientY - swipeStartY;
      if (Math.abs(sdx) > DRAG_THRESHOLD || Math.abs(sdy) > DRAG_THRESHOLD) {
        movedOnLastInteraction = true;
      }
    }
  });

  function endPanOrSwipe(e) {
    if (!isOpen) return;

    // Fin del pan
    if (isPanning) {
      try { imgEl.releasePointerCapture(e.pointerId); } catch(err) {}
      isPanning = false;
      imgEl.style.cursor = scale > 1.02 ? 'grab' : 'zoom-in';
    }

    // Detectar swipe solo sin zoom
    if (swipeTracking && scale <= 1.02) {
      swipeTracking = false;

      var dx = e.clientX - swipeStartX;
      var dy = e.clientY - swipeStartY;

      if (Math.abs(dx) >= SWIPE_MIN_DISTANCE &&
          Math.abs(dy) <= SWIPE_MAX_OFF_AXIS) {
        if (dx < 0) {
          nextImage();
        } else {
          prevImage();
        }
        movedOnLastInteraction = true;
      }
    }
  }

  imgEl.addEventListener('pointerup', endPanOrSwipe);
  imgEl.addEventListener('pointercancel', endPanOrSwipe);

  /* ---------- Pinch-to-zoom solo en el modal ---------- */

  modal.addEventListener('pointerdown', function(e) {
    if (!isOpen) return;
    pointers[e.pointerId] = e;

    var keys = Object.keys(pointers);
    if (keys.length === 2) {
      // dos dedos: empezamos pinch
      var p1 = pointers[keys[0]];
      var p2 = pointers[keys[1]];
      initialPinchDist = Math.hypot(
        p2.clientX - p1.clientX,
        p2.clientY - p1.clientY
      );
      pinchStartScale = scale;
    }
  });

  modal.addEventListener('pointermove', function(e) {
    if (!isOpen) return;

    if (pointers[e.pointerId]) {
      pointers[e.pointerId] = e;
    }

    var keys = Object.keys(pointers);
    if (keys.length === 2 && initialPinchDist > 0) {
      // Bloquear zoom nativo del navegador en este gesto
      if (e.cancelable) e.preventDefault();

      var p1 = pointers[keys[0]];
      var p2 = pointers[keys[1]];
      var dist = Math.hypot(
        p2.clientX - p1.clientX,
        p2.clientY - p1.clientY
      );

      var rawFactor = dist / initialPinchDist;
      var factor = 1 + (rawFactor - 1) * PINCH_SENSITIVITY;

      scale = clamp(pinchStartScale * factor, minScale, maxScale);
      isZoomed = scale > 1.02;

      if (isZoomed) {
        modal.classList.add('is-zoomed');
        imgEl.style.cursor = 'grab';
      } else {
        modal.classList.remove('is-zoomed');
        imgEl.style.cursor = 'zoom-in';
        lastX = lastY = 0;
      }

      applyTransform();
    }
  });

  function clearPointer(e) {
    delete pointers[e.pointerId];
    var keys = Object.keys(pointers);
    if (keys.length < 2) {
      initialPinchDist = 0;
      pinchStartScale = scale;
    }
  }

  modal.addEventListener('pointerup', clearPointer);
  modal.addEventListener('pointercancel', clearPointer);

  /* ---------- Click en la imagen: zoom in / zoom out ---------- */

  imgEl.addEventListener('click', function() {
    if (!isOpen) return;

    if (movedOnLastInteraction) {
      movedOnLastInteraction = false;
      return;
    }

    if (scale > 1.02) {
      resetTransform();
    } else {
      toggleZoomIn();
    }
  });

  /* ---------- Navegación botones ---------- */

  prevBtn && prevBtn.addEventListener('click', function(e) {
    e.preventDefault();
    prevImage();
  });

  nextBtn && nextBtn.addEventListener('click', function(e) {
    e.preventDefault();
    nextImage();
  });

  closeBtn && closeBtn.addEventListener('click', function(e) {
    e.preventDefault();
    closeModal();
  });

  /* ---------- Cerrar al click fuera de imagen/controles ---------- */

  modal.addEventListener('click', function(e) {
    if (!isOpen) return;
    var isInsideImg = imgEl.contains(e.target);
    var isCtrl      = e.target.closest('.celestZoom__controls');
    if (!isInsideImg && !isCtrl) {
      closeModal();
    }
  });

  /* ---------- Triggers desde la galería ---------- */

  function openVideoFullscreenFromSlide(slide) {
    var videoEl = slide.querySelector('video');
    if (!videoEl) return false;

    // Reproducir y tratar de entrar en fullscreen nativo
    try { videoEl.play().catch(function(){}); } catch(err) {}

    if (videoEl.requestFullscreen) {
      videoEl.requestFullscreen().catch(function() {});
    } else if (videoEl.webkitEnterFullscreen) {
      // Soporte iOS Safari
      videoEl.webkitEnterFullscreen();
    }
    return true;
  }

  function initGalleryTriggers() {
    var gallery = root.querySelector('.celestPdp__slides');
    if (!gallery || gallery.__celestZoomBound) return;
    gallery.__celestZoomBound = true;

    // Click/tap en cualquier slide visible abre zoom
    gallery.addEventListener('click', function(e) {
      var slide = e.target.closest('.celestPdp__slide');
      if (!slide) return;

      // Si es VIDEO, no usamos el modal de zoom: abrimos el video.
      if (openVideoFullscreenFromSlide(slide)) {
        e.preventDefault();
        return;
      }

      var visible = getVisibleSlides().map(function(s) { return s.el; });
      var idx = visible.indexOf(slide);
      if (idx < 0) idx = 0;

      e.preventDefault();
      openModal(idx);
    });

    // Icono "+" minimal en cada slide (solo mobile via CSS)
    var slides = gallery.querySelectorAll('.celestPdp__slide');
    slides.forEach(function(slide) {
       if (slide.querySelector('.celestZoom__iconMobile')) return; 
      var icon = document.createElement('button');
      icon.type = 'button';
      icon.className = 'celestZoom__iconMobile';
      icon.innerHTML = '<span aria-hidden="true"></span>';

      if (!slide.style.position || slide.style.position === 'static') {
        slide.style.position = 'relative';
      }

      slide.appendChild(icon);

      icon.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();

        // Si el slide tiene VIDEO, abrimos ese video en fullscreen
        if (openVideoFullscreenFromSlide(slide)) {
          return;
        }

        var visible = getVisibleSlides().map(function(s) { return s.el; });
        var idx = visible.indexOf(slide);
        openModal(idx >= 0 ? idx : 0);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initGalleryTriggers);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initGalleryTriggers();
  }

  /* ---------- Hook opcional cambios de variante ----------
     document.addEventListener('celest:variant:change', refreshSlidesData);
   ---------------------------------------------------------- */


})();
/* =========================================================
   CELEST • Auto-selección de talla única v2
   - Funciona al cargar la PDP
   - Y cada vez que cambias de color / variante
   - Solo actúa cuando hay EXACTAMENTE 1 talla disponible
   - No rompe tu flujo actual: reutiliza los mismos eventos de click
   ========================================================= */

(function(){
  // Función reutilizable (queda en window por si la necesitas luego)
  function celestAutoSelectSingleSizeV2(){
    var root = document.querySelector('#celest-mobile-pdp');
    if (!root) return;

    // Popover / sheet de tallas
    var sizeSheet = root.querySelector('.celestPdp__sizeSheet');
    if (!sizeSheet) return;

    // Tallas DISPONIBLES (no deshabilitadas)
    var availableSizes = Array.prototype.filter.call(
      sizeSheet.querySelectorAll('.celestPdp__size'),
      function(el){
        // ignoramos las que estén deshabilitadas o marcadas sin stock
        if (el.classList.contains('is-disabled')) return false;
        if (el.hasAttribute('disabled')) return false;
        return true;
      }
    );

    // Si no hay tallas, o hay 0 / más de 1 → NO hacemos nada
    if (availableSizes.length !== 1) return;

    var onlySize = availableSizes[0];

    // Si ya está activa, no repetimos
    if (onlySize.classList.contains('is-active')) return;

    // Botón grande de "Selecciona tu talla"
    var sizeBtn = root.querySelector('.celestPdp__sizeBtn');
    if (!sizeBtn) return;

    // Disparamos el click sobre la única talla disponible:
    // - Marca .is-active
    // - Actualiza el label del botón
    // - Actualiza inventario, CTA, etc.
    onlySize.click();
  }

  // Exponemos la función para que puedas llamarla desde otros scripts si quieres
  window.celestAutoSelectSingleSizeV2 = celestAutoSelectSingleSizeV2;

  /* 1) Ejecutar una vez al cargar la página (por si el producto tiene una sola talla) */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      // pequeño delay para dar tiempo a Shopify a pintar las tallas
      setTimeout(celestAutoSelectSingleSizeV2, 80);
    });
  } else {
    setTimeout(celestAutoSelectSingleSizeV2, 80);
  }

  /* 2) Re-ejecutar cuando cambias de color / variante
        - Click en swatches de color (.celestPdp__swatch)
        - Y, si tu JS lanza un evento custom de variante, también lo escuchamos
  */

  // a) Click en swatches de color
  document.addEventListener('click', function(ev){
    var swatch = ev.target.closest('#celest-mobile-pdp .celestPdp__swatch');
    if (!swatch) return;

    // Damos un tiempo para que tu lógica actual actualice tallas, stock, etc.
    setTimeout(celestAutoSelectSingleSizeV2, 120);
  });

  // b) Evento custom opcional: por si tu script ya dispara algo como "celest:variant:changed"
  document.addEventListener('celest:variant:changed', function(){
    setTimeout(celestAutoSelectSingleSizeV2, 80);
  });
 // ELIMINAR ÍTEM DEL MINI-CART POR KEY (misma lógica que + / -)
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".celestPdp__deleteItem");
  if (!btn) return;

  const key = btn.dataset.key;
  if (!key) {
    console.warn("Delete: no data-key en el botón");
    return;
  }

  const refreshMiniCart = async () => {
    const rc   = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
    const cart = await rc.json();
    // Usamos el bridge existente para re-renderizar el mini-cart
    document.dispatchEvent(
      new CustomEvent("celest:openMiniCart", { detail: { cart } })
    );
  };

  try {
    btn.classList.add("is-loading");

    // 1) Igual que los botones + / - : usamos id = key
    let res = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    });

    // 2) Fallback por si algo falla: buscamos la línea y borramos por line
    if (!res.ok) {
      const cartRes = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
      const cart    = await cartRes.json();
      const index   = cart.items.findIndex((item) => item.key === key);
      if (index !== -1) {
        const line = index + 1;
        res = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ line, quantity: 0 })
        });
      }
    }

    await refreshMiniCart();
  } catch (err) {
    console.error("Error eliminando item del mini-cart:", err);
  } finally {
    btn.classList.remove("is-loading");
  }
});

})();
/* =========================================================
   CELEST • Precio dinámico por variante (PDP)
   - Lee price / compare_at_price de la variante seleccionada
   - Actualiza un único contenedor de precio en la PDP
   - Soporta eventos variant:change / product:variant-change /
     celest:variant:changed + fallback observando input[name="id"]
   ========================================================= */
(function(){
  const root = document.getElementById('celest-mobile-pdp');
  if (!root) return;

  // ---- 1. Obtener JSON de producto ----
  function safeJSON(el){
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); }
    catch(_){ return null; }
  }

  let product =
    safeJSON(document.getElementById('ProductJson-celest-mobile-pdp')) ||
    safeJSON(root.querySelector('#ProductJson-product-template')) ||
    (function(){
      const anyJson = root.querySelector('.product__json, script[type="application/json"]');
      return safeJSON(anyJson);
    })() ||
    (window.meta && window.meta.product) ||
    (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) ||
    null;

  if (!product || !Array.isArray(product.variants) || !product.variants.length) return;

  // ---- 2. Resolver contenedor de precio ----
  function resolvePriceSlot(){
    // 1) Contenedores explícitos
    let container =
      root.querySelector('[data-variant-price]') ||
      root.querySelector('#celest-variant-price') ||
      root.querySelector('.celestPdp__priceMain') ||
      root.querySelector('.product__price, .price, .ProductMeta__Price');

    if (!container) return null;

    // Aseguramos un "slot" interno que controlamos nosotros
    let slot = container.querySelector('.js-celest-variant-price');
    if (!slot){
      slot = document.createElement('span');
      slot.className = 'js-celest-variant-price';

      // Movemos el contenido actual dentro del slot para no perder estilos
      while (container.firstChild){
        slot.appendChild(container.firstChild);
      }
      container.appendChild(slot);
    }

    // Accesibilidad: aria-live para avisar cambios de precio
    if (!container.hasAttribute('aria-live')){
      container.setAttribute('aria-live', 'polite');
    }

    return slot;
  }

  const priceSlot = resolvePriceSlot();
  if (!priceSlot) return;

  // ---- 3. Helpers de formateo de moneda ----
  function resolveMoneyFormat(){
    // Buscar en data-attributes y en tema
    const htmlFmt  = document.documentElement.getAttribute('data-money-format');
    const bodyFmt  = document.body.getAttribute('data-money-format');
    const rootFmt  = root.getAttribute('data-money-format');
    return window.moneyFormat || rootFmt || bodyFmt || htmlFmt || '${{amount}}';
  }

  const MONEY_FORMAT = resolveMoneyFormat();

  function formatMoney(cents){
    cents = Number(cents || 0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function'){
      return Shopify.formatMoney(cents, MONEY_FORMAT);
    }
    // Fallback simple (sin decimales, útil para COP)
    const value = cents / 100;
    try {
      return value.toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    } catch(_){
      return '$ ' + Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }

  function findVariantById(id){
    if (!id) return null;
    return product.variants.find(v => String(v.id) === String(id)) || null;
  }

  function getDefaultVariant(){
    // 1) selected_or_first_available_variant del JSON
    if (product.selected_or_first_available_variant) return product.selected_or_first_available_variant;
    // 2) input[name="id"]
    const idInput = root.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      const v = findVariantById(idInput.value);
      if (v) return v;
    }
    // 3) Primera variante disponible / primera
    return product.variants.find(v => v.available) || product.variants[0] || null;
  }

  // ---- 4. Renderizar precio según variante ----
function renderVariantPrice(variant){
  if (!variant || !priceSlot) return;

  const priceCents   = Number(variant.price || 0);
  const compareCents = Number(variant.compare_at_price || 0);

  const hasDiscount = compareCents > priceCents && compareCents > 0;
  let html = '';

  if (hasDiscount){
    // 👉 Precio con descuento a la IZQUIERDA
    // 👉 Precio anterior a la DERECHA y tachado (CSS abajo)
    html = `
      <span class="celestPrice celestPrice--sale">
        ${formatMoney(priceCents)}
      </span>
      <span class="celestPrice celestPrice--compare">
        ${formatMoney(compareCents)}
      </span>
    `;
  } else {
    // Sin descuento → solo precio actual
    html = `
      <span class="celestPrice celestPrice--regular">
        ${formatMoney(priceCents)}
      </span>
    `;
  }

  priceSlot.innerHTML = html.trim();
}


  // ---- 5. Handlers de eventos de variante ----
  function handleVariantEvent(ev){
    if (!ev) return;

    let v = null;
    const d = ev.detail || {};

    // Casos típicos de temas:
    //  - detail.variant
    //  - detail.variantData
    //  - detail.selectedVariant
    v = d.variant || d.variantData || d.selectedVariant || null;

    // Si solo viene el id en detail.id, lo buscamos
    if (!v && d.id) {
      v = findVariantById(d.id);
    }

    // Si el target es un input[name="id"], usamos su value
    if (!v && ev.target && ev.target.name === 'id') {
      v = findVariantById(ev.target.value);
    }

    if (!v) return;
    renderVariantPrice(v);
  }

  // ---- 6. Suscripción a eventos del tema ----
  ['variant:change', 'product:variant-change', 'celest:variant:changed']
    .forEach(evtName => {
      document.addEventListener(evtName, handleVariantEvent);
    });

  // ---- 7. Fallback: observar cambios en input[name="id"] ----
  (function watchIdInput(){
    const idInput = root.querySelector('input[name="id"]');
    if (!idInput) return;

    let lastId = idInput.value || '';

    function check(){
      const current = idInput.value || '';
      if (current && current !== lastId){
        lastId = current;
        const v = findVariantById(current);
        if (v) renderVariantPrice(v);
      }
    }

    idInput.addEventListener('change', check);
    idInput.addEventListener('input', check);

    if ('MutationObserver' in window){
      const mo = new MutationObserver(check);
      mo.observe(idInput, { attributes:true, attributeFilter:['value'] });
    }
  })();

  // ---- 8. Render inicial ----
  const initialVariant = getDefaultVariant();
  if (initialVariant) renderVariantPrice(initialVariant);

})();  
/* ================================
   CELEST • Size Guide Modal — FIX (robusto)
   - Abre aunque el modal esté fuera de #celest-mobile-pdp
   - Cierra por X, click fuera, y tecla ESC
   - No depende de $ ni de closeSizes()
================================== */
(function(){
  const root = document.getElementById('celest-mobile-pdp');
  if(!root) return;
  if(root.__celestGuideBound) return;
  root.__celestGuideBound = true;

  // Puede estar dentro del root o fuera (por estructura Liquid)
  const guideWrap =
    root.querySelector('.celestPdp__guideModal') ||
    document.querySelector('.celestPdp__guideModal');

  if(!guideWrap) return;

  const guideBody =
    guideWrap.querySelector('.celestPdp__guideBody') || guideWrap;

  const openers = Array.from(root.querySelectorAll('.js-openGuide'));
  const closers = () => Array.from(guideWrap.querySelectorAll('.celestPdp__guideClose'));

  function openGuide(e){
    if(e){ e.preventDefault(); e.stopPropagation(); }

    // (Opcional) si existe un size sheet abierto, lo cerramos sin depender de closeSizes()
    try{
      const sheet = root.querySelector('.celestPdp__sizeSheet');
      if(sheet){
        sheet.classList.remove('is-open');
        // si tu sheet usa hidden, lo respetamos
        if(!sheet.hasAttribute('hidden')) sheet.setAttribute('hidden','');
      }
    }catch(_){}

    guideWrap.hidden = false;
    guideWrap.setAttribute('aria-hidden','false');

    // Clase en body y/o wrap (por si tu CSS anima uno u otro)
    requestAnimationFrame(()=>{
      guideWrap.classList.add('is-open');
      guideBody.classList.add('is-open');
    });

    // Evita scroll detrás en móvil
    if (matchMedia('(max-width: 989px)').matches) {
      document.body.style.overflow = 'hidden';
    }
  }

  function closeGuide(e){
    if(e){ e.preventDefault(); e.stopPropagation(); }

    guideWrap.classList.remove('is-open');
    guideBody.classList.remove('is-open');
    guideWrap.setAttribute('aria-hidden','true');

    // Si hay transición, esperamos; si no, ocultamos con fallback
    let done = false;
    const finish = ()=>{
      if(done) return;
      done = true;
      guideWrap.hidden = true;
      document.body.style.overflow = '';
    };

    guideBody.addEventListener('transitionend', finish, { once:true });
    setTimeout(finish, 260); // fallback seguro
  }

  // Bind open
  openers.forEach(btn=>{
    btn.addEventListener('click', openGuide, { passive:false });
  });

  // Bind close (X)
  const bindClosers = ()=>{
    closers().forEach(btn=>{
      if(btn.__celestGuideCloseBound) return;
      btn.__celestGuideCloseBound = true;
      btn.addEventListener('click', closeGuide, { passive:false });
    });
  };
  bindClosers();

  // Click fuera (overlay)
  guideWrap.addEventListener('click', (e)=>{
    // si se hace click fuera del cuerpo, cerramos
    if(e.target === guideWrap) closeGuide(e);
  }, { passive:false });

  // ESC para cerrar
  document.addEventListener('keydown', (e)=>{
    if(e.key === 'Escape' && !guideWrap.hidden){
      closeGuide(e);
    }
  });

  // Si el contenido de la guía se re-renderiza, re-bindea la X
  if('MutationObserver' in window){
    const mo = new MutationObserver(()=>bindClosers());
    mo.observe(guideWrap, { childList:true, subtree:true });
  }
})();


/* =========================
   CELEST • ADDI (Load ONCE)
   - No reinyecta el script al cambiar variante
   - Monta el widget dentro de .celestAddiWrap
========================= */
(function(){
  const ADDI_SRC  = "https://statics.addi.com/shopify/js/shopify-co-widget-wrapper.bundle.min.js";
  const ADDI_ID   = "celestlauret-ecommerce";
  const SCRIPT_ID = "celest-addi-script-once";

  function ensurePriceClass(){
    const root = document.getElementById("celest-mobile-pdp");
    if(!root) return;
    const priceEl = root.querySelector(".celestPdp__priceRow .price");
    if(priceEl && !priceEl.classList.contains("celestPrice--regular")){
      priceEl.classList.add("celestPrice--regular");
    }
  }

  function ensureAddiScriptOnce(){
    const root = document.getElementById("celest-mobile-pdp");
    if(!root) return;

    // Debe existir el contenedor
    const mount = root.querySelector("[data-celest-addi]");
    if(!mount) return;

    // Ya cargado
    if(document.getElementById(SCRIPT_ID)) return;

    // Crea el script 1 sola vez
    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    s.src = ADDI_SRC;
    s.defer = true;

    // Addi lee estos data-attrs para inicializar
    s.dataset.name = "shopifyAddiWidget";
    s.dataset.id = ADDI_ID;
    s.dataset.allySlug = ADDI_ID;

    // 🔥 Clave: referencia al contenedor estable (evita depender del nodo del precio que suele re-renderizar)
    s.dataset.elementReference = "#celest-mobile-pdp [data-celest-addi]";

    document.body.appendChild(s);
  }

  function boot(){
    ensurePriceClass();
    ensureAddiScriptOnce();

    // Si tu JS reemplaza partes del DOM, al menos reaseguramos la clase del precio (SIN recargar Addi)
    const root = document.getElementById("celest-mobile-pdp");
    if(root){
      const mo = new MutationObserver(() => {
        ensurePriceClass();
        // NO volvemos a inyectar script si ya existe
        ensureAddiScriptOnce();
      });
      mo.observe(root, { childList:true, subtree:true });
    }
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
